import { Block, Document } from "./newsdoc/newsdoc.mjs";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType, UnknownFieldHandler, WireType, reflectionMergePartial } from "@protobuf-ts/runtime";
// src/repository/service.ts
/**
* @generated from protobuf enum elephant.repository.GetMetaDoc
*/
let GetMetaDoc = /* @__PURE__ */ function(GetMetaDoc) {
	/**
	* @generated from protobuf enum value: META_NONE = 0;
	*/
	GetMetaDoc[GetMetaDoc["META_NONE"] = 0] = "META_NONE";
	/**
	* @generated from protobuf enum value: META_INCLUDE = 1;
	*/
	GetMetaDoc[GetMetaDoc["META_INCLUDE"] = 1] = "META_INCLUDE";
	/**
	* @generated from protobuf enum value: META_ONLY = 2;
	*/
	GetMetaDoc[GetMetaDoc["META_ONLY"] = 2] = "META_ONLY";
	return GetMetaDoc;
}({});
/**
* LockExclusivity controls which operations a document lock blocks for
* callers that don't hold the lock token. Document updates (new versions,
* deletes) are always blocked by a lock; the exclusivity level can extend
* the lock to also cover status and ACL updates.
*
* @generated from protobuf enum elephant.repository.LockExclusivity
*/
let LockExclusivity = /* @__PURE__ */ function(LockExclusivity) {
	/**
	* Block document updates only. Statuses and ACLs can still be updated
	* by others. This is the default.
	*
	* @generated from protobuf enum value: LOCK_DOCUMENT = 0;
	*/
	LockExclusivity[LockExclusivity["LOCK_DOCUMENT"] = 0] = "LOCK_DOCUMENT";
	/**
	* Block document and status updates.
	*
	* @generated from protobuf enum value: LOCK_STATUS = 1;
	*/
	LockExclusivity[LockExclusivity["LOCK_STATUS"] = 1] = "LOCK_STATUS";
	/**
	* Block document and ACL updates.
	*
	* @generated from protobuf enum value: LOCK_ACL = 2;
	*/
	LockExclusivity[LockExclusivity["LOCK_ACL"] = 2] = "LOCK_ACL";
	/**
	* Block document, status, and ACL updates.
	*
	* @generated from protobuf enum value: LOCK_EXCLUSIVE = 3;
	*/
	LockExclusivity[LockExclusivity["LOCK_EXCLUSIVE"] = 3] = "LOCK_EXCLUSIVE";
	return LockExclusivity;
}({});
/**
* @generated from protobuf enum elephant.repository.SchemaActivation
*/
let SchemaActivation = /* @__PURE__ */ function(SchemaActivation) {
	/**
	* No activation status.
	*
	* @generated from protobuf enum value: ACTIVATION_UNKNOWN = 0;
	*/
	SchemaActivation[SchemaActivation["ACTIVATION_UNKNOWN"] = 0] = "ACTIVATION_UNKNOWN";
	/**
	* Active schema generations are used to determine whether documents are valid.
	*
	* @generated from protobuf enum value: ACTIVATION_ACTIVE = 1;
	*/
	SchemaActivation[SchemaActivation["ACTIVATION_ACTIVE"] = 1] = "ACTIVATION_ACTIVE";
	/**
	* Pending schema generations are used for soft validation and we log
	* validation errors for it. The currently active schema generation still has
	* the last say in whether a document is valid or not.
	*
	* @generated from protobuf enum value: ACTIVATION_PENDING = 2;
	*/
	SchemaActivation[SchemaActivation["ACTIVATION_PENDING"] = 2] = "ACTIVATION_PENDING";
	/**
	* Deactivated schema generation.
	*
	* @generated from protobuf enum value: ACTIVATION_DEACTIVATED = 3;
	*/
	SchemaActivation[SchemaActivation["ACTIVATION_DEACTIVATED"] = 3] = "ACTIVATION_DEACTIVATED";
	return SchemaActivation;
}({});
/**
* @generated from protobuf enum elephant.repository.MetricAggregation
*/
let MetricAggregation = /* @__PURE__ */ function(MetricAggregation) {
	/**
	* @generated from protobuf enum value: NONE = 0;
	*/
	MetricAggregation[MetricAggregation["NONE"] = 0] = "NONE";
	/**
	* @generated from protobuf enum value: REPLACE = 1;
	*/
	MetricAggregation[MetricAggregation["REPLACE"] = 1] = "REPLACE";
	/**
	* @generated from protobuf enum value: INCREMENT = 2;
	*/
	MetricAggregation[MetricAggregation["INCREMENT"] = 2] = "INCREMENT";
	return MetricAggregation;
}({});
/**
* @generated from protobuf enum elephant.repository.FilterOperator
*/
let FilterOperator = /* @__PURE__ */ function(FilterOperator) {
	/**
	* @generated from protobuf enum value: FILTER_OP_UNKNOWN = 0;
	*/
	FilterOperator[FilterOperator["FILTER_OP_UNKNOWN"] = 0] = "FILTER_OP_UNKNOWN";
	/**
	* @generated from protobuf enum value: FILTER_OP_ANY = 1;
	*/
	FilterOperator[FilterOperator["FILTER_OP_ANY"] = 1] = "FILTER_OP_ANY";
	/**
	* @generated from protobuf enum value: FILTER_OP_ALL = 2;
	*/
	FilterOperator[FilterOperator["FILTER_OP_ALL"] = 2] = "FILTER_OP_ALL";
	/**
	* @generated from protobuf enum value: FILTER_OP_NONE = 3;
	*/
	FilterOperator[FilterOperator["FILTER_OP_NONE"] = 3] = "FILTER_OP_NONE";
	return FilterOperator;
}({});
var EvictRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.EvictRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "until_version",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.version = 0n;
		message.untilVersion = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					message.untilVersion = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		if (message.untilVersion !== 0n) writer.tag(3, WireType.Varint).int64(message.untilVersion);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.EvictRequest
*/
const EvictRequest = new EvictRequest$Type();
var EvictResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.EvictResponse", [{
			no: 1,
			name: "evict_count",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.evictCount = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.evictCount = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.evictCount !== 0n) writer.tag(1, WireType.Varint).int64(message.evictCount);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.EvictResponse
*/
const EvictResponse = new EvictResponse$Type();
var GetStatusRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.name = "";
		message.id = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				case 3:
					message.id = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		if (message.id !== 0n) writer.tag(3, WireType.Varint).int64(message.id);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusRequest
*/
const GetStatusRequest = new GetStatusRequest$Type();
var GetStatusResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusResponse", [{
			no: 1,
			name: "status",
			kind: "message",
			T: () => Status
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.status = Status.internalBinaryRead(reader, reader.uint32(), options, message.status);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.status) Status.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusResponse
*/
const GetStatusResponse = new GetStatusResponse$Type();
var GetStatusHistoryRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusHistoryRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "before",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.name = "";
		message.before = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				case 3:
					message.before = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		if (message.before !== 0n) writer.tag(3, WireType.Varint).int64(message.before);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusHistoryRequest
*/
const GetStatusHistoryRequest = new GetStatusHistoryRequest$Type();
var GetStatusHistoryReponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusHistoryReponse", [{
			no: 1,
			name: "statuses",
			kind: "message",
			repeat: 2,
			T: () => Status
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.statuses = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.statuses.push(Status.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.statuses.length; i++) Status.internalBinaryWrite(message.statuses[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusHistoryReponse
*/
const GetStatusHistoryReponse = new GetStatusHistoryReponse$Type();
var GetNilStatusesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetNilStatusesRequest", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "names",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.names = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.names.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		for (let i = 0; i < message.names.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.names[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetNilStatusesRequest
*/
const GetNilStatusesRequest = new GetNilStatusesRequest$Type();
var GetNilStatusesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetNilStatusesResponse", [{
			no: 1,
			name: "statuses",
			kind: "map",
			K: 9,
			V: {
				kind: "message",
				T: () => DocumentStatuses
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.statuses = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					this.binaryReadMap1(message.statuses, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap1(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = DocumentStatuses.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.GetNilStatusesResponse.statuses");
			}
		}
		map[key ?? ""] = val ?? DocumentStatuses.create();
	}
	internalBinaryWrite(message, writer, options) {
		for (let k of globalThis.Object.keys(message.statuses)) {
			writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			DocumentStatuses.internalBinaryWrite(message.statuses[k], writer, options);
			writer.join().join();
		}
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetNilStatusesResponse
*/
const GetNilStatusesResponse = new GetNilStatusesResponse$Type();
var GetStatusOverviewRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusOverviewRequest", [
			{
				no: 1,
				name: "uuids",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 2,
				name: "statuses",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 3,
				name: "get_meta",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuids = [];
		message.statuses = [];
		message.getMeta = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuids.push(reader.string());
					break;
				case 2:
					message.statuses.push(reader.string());
					break;
				case 3:
					message.getMeta = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.uuids.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.uuids[i]);
		for (let i = 0; i < message.statuses.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.statuses[i]);
		if (message.getMeta !== false) writer.tag(3, WireType.Varint).bool(message.getMeta);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusOverviewRequest
*/
const GetStatusOverviewRequest = new GetStatusOverviewRequest$Type();
var GetStatusOverviewResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusOverviewResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => StatusOverviewItem
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(StatusOverviewItem.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) StatusOverviewItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusOverviewResponse
*/
const GetStatusOverviewResponse = new GetStatusOverviewResponse$Type();
var StatusOverviewItem$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.StatusOverviewItem", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "modified",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "heads",
				kind: "map",
				K: 9,
				V: {
					kind: "message",
					T: () => Status
				}
			},
			{
				no: 5,
				name: "workflow_state",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "workflow_checkpoint",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "creator_uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "updater_uri",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.version = 0n;
		message.modified = "";
		message.heads = {};
		message.workflowState = "";
		message.workflowCheckpoint = "";
		message.creatorUri = "";
		message.updaterUri = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					message.modified = reader.string();
					break;
				case 4:
					this.binaryReadMap4(message.heads, reader, options);
					break;
				case 5:
					message.workflowState = reader.string();
					break;
				case 6:
					message.workflowCheckpoint = reader.string();
					break;
				case 7:
					message.creatorUri = reader.string();
					break;
				case 8:
					message.updaterUri = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap4(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = Status.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.StatusOverviewItem.heads");
			}
		}
		map[key ?? ""] = val ?? Status.create();
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		if (message.modified !== "") writer.tag(3, WireType.LengthDelimited).string(message.modified);
		for (let k of globalThis.Object.keys(message.heads)) {
			writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			Status.internalBinaryWrite(message.heads[k], writer, options);
			writer.join().join();
		}
		if (message.workflowState !== "") writer.tag(5, WireType.LengthDelimited).string(message.workflowState);
		if (message.workflowCheckpoint !== "") writer.tag(6, WireType.LengthDelimited).string(message.workflowCheckpoint);
		if (message.creatorUri !== "") writer.tag(7, WireType.LengthDelimited).string(message.creatorUri);
		if (message.updaterUri !== "") writer.tag(8, WireType.LengthDelimited).string(message.updaterUri);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.StatusOverviewItem
*/
const StatusOverviewItem = new StatusOverviewItem$Type();
var GetPermissionsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetPermissionsRequest", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetPermissionsRequest
*/
const GetPermissionsRequest = new GetPermissionsRequest$Type();
var GetPermissionsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetPermissionsResponse", [{
			no: 1,
			name: "permissions",
			kind: "map",
			K: 9,
			V: {
				kind: "scalar",
				T: 9
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.permissions = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					this.binaryReadMap1(message.permissions, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap1(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.GetPermissionsResponse.permissions");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		for (let k of globalThis.Object.keys(message.permissions)) writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.permissions[k]).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetPermissionsResponse
*/
const GetPermissionsResponse = new GetPermissionsResponse$Type();
var GetEventlogRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetEventlogRequest", [
			{
				no: 1,
				name: "after",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "wait_ms",
				kind: "scalar",
				T: 5
			},
			{
				no: 3,
				name: "batch_size",
				kind: "scalar",
				T: 5
			},
			{
				no: 4,
				name: "batch_wait_ms",
				kind: "scalar",
				T: 5
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.after = 0n;
		message.waitMs = 0;
		message.batchSize = 0;
		message.batchWaitMs = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.after = reader.int64().toBigInt();
					break;
				case 2:
					message.waitMs = reader.int32();
					break;
				case 3:
					message.batchSize = reader.int32();
					break;
				case 4:
					message.batchWaitMs = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.after !== 0n) writer.tag(1, WireType.Varint).int64(message.after);
		if (message.waitMs !== 0) writer.tag(2, WireType.Varint).int32(message.waitMs);
		if (message.batchSize !== 0) writer.tag(3, WireType.Varint).int32(message.batchSize);
		if (message.batchWaitMs !== 0) writer.tag(4, WireType.Varint).int32(message.batchWaitMs);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetEventlogRequest
*/
const GetEventlogRequest = new GetEventlogRequest$Type();
var GetEventlogResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetEventlogResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => EventlogItem
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(EventlogItem.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) EventlogItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetEventlogResponse
*/
const GetEventlogResponse = new GetEventlogResponse$Type();
var GetCompactedEventlogRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetCompactedEventlogRequest", [
			{
				no: 1,
				name: "after",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "until",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 4,
				name: "limit",
				kind: "scalar",
				T: 5
			},
			{
				no: 5,
				name: "offset",
				kind: "scalar",
				T: 5
			},
			{
				no: 6,
				name: "type",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.after = 0n;
		message.until = 0n;
		message.limit = 0;
		message.offset = 0;
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.after = reader.int64().toBigInt();
					break;
				case 3:
					message.until = reader.int64().toBigInt();
					break;
				case 4:
					message.limit = reader.int32();
					break;
				case 5:
					message.offset = reader.int32();
					break;
				case 6:
					message.type = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.after !== 0n) writer.tag(1, WireType.Varint).int64(message.after);
		if (message.until !== 0n) writer.tag(3, WireType.Varint).int64(message.until);
		if (message.limit !== 0) writer.tag(4, WireType.Varint).int32(message.limit);
		if (message.offset !== 0) writer.tag(5, WireType.Varint).int32(message.offset);
		if (message.type !== "") writer.tag(6, WireType.LengthDelimited).string(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetCompactedEventlogRequest
*/
const GetCompactedEventlogRequest = new GetCompactedEventlogRequest$Type();
var GetCompactedEventlogResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetCompactedEventlogResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => EventlogItem
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(EventlogItem.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) EventlogItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetCompactedEventlogResponse
*/
const GetCompactedEventlogResponse = new GetCompactedEventlogResponse$Type();
var EventlogItem$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.EventlogItem", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "event",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "timestamp",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 6,
				name: "status",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "status_id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 8,
				name: "acl",
				kind: "message",
				repeat: 2,
				T: () => ACLEntry
			},
			{
				no: 9,
				name: "updater_uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 11,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 12,
				name: "old_language",
				kind: "scalar",
				T: 9
			},
			{
				no: 13,
				name: "main_document",
				kind: "scalar",
				T: 9
			},
			{
				no: 14,
				name: "system_state",
				kind: "scalar",
				T: 9
			},
			{
				no: 15,
				name: "workflow_state",
				kind: "scalar",
				T: 9
			},
			{
				no: 16,
				name: "workflow_checkpoint",
				kind: "scalar",
				T: 9
			},
			{
				no: 17,
				name: "main_document_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 18,
				name: "attached_objects",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 19,
				name: "detached_objects",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 20,
				name: "delete_record_id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 21,
				name: "document_nonce",
				kind: "scalar",
				T: 9
			},
			{
				no: 22,
				name: "timespans",
				kind: "message",
				repeat: 2,
				T: () => Timespan
			},
			{
				no: 23,
				name: "labels",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 24,
				name: "schema_generation",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.event = "";
		message.uuid = "";
		message.timestamp = "";
		message.version = 0n;
		message.status = "";
		message.statusId = 0n;
		message.acl = [];
		message.updaterUri = "";
		message.type = "";
		message.language = "";
		message.oldLanguage = "";
		message.mainDocument = "";
		message.systemState = "";
		message.workflowState = "";
		message.workflowCheckpoint = "";
		message.mainDocumentType = "";
		message.attachedObjects = [];
		message.detachedObjects = [];
		message.deleteRecordId = 0n;
		message.documentNonce = "";
		message.timespans = [];
		message.labels = [];
		message.schemaGeneration = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.event = reader.string();
					break;
				case 3:
					message.uuid = reader.string();
					break;
				case 4:
					message.timestamp = reader.string();
					break;
				case 5:
					message.version = reader.int64().toBigInt();
					break;
				case 6:
					message.status = reader.string();
					break;
				case 7:
					message.statusId = reader.int64().toBigInt();
					break;
				case 8:
					message.acl.push(ACLEntry.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 9:
					message.updaterUri = reader.string();
					break;
				case 10:
					message.type = reader.string();
					break;
				case 11:
					message.language = reader.string();
					break;
				case 12:
					message.oldLanguage = reader.string();
					break;
				case 13:
					message.mainDocument = reader.string();
					break;
				case 14:
					message.systemState = reader.string();
					break;
				case 15:
					message.workflowState = reader.string();
					break;
				case 16:
					message.workflowCheckpoint = reader.string();
					break;
				case 17:
					message.mainDocumentType = reader.string();
					break;
				case 18:
					message.attachedObjects.push(reader.string());
					break;
				case 19:
					message.detachedObjects.push(reader.string());
					break;
				case 20:
					message.deleteRecordId = reader.int64().toBigInt();
					break;
				case 21:
					message.documentNonce = reader.string();
					break;
				case 22:
					message.timespans.push(Timespan.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 23:
					message.labels.push(reader.string());
					break;
				case 24:
					message.schemaGeneration = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.event !== "") writer.tag(2, WireType.LengthDelimited).string(message.event);
		if (message.uuid !== "") writer.tag(3, WireType.LengthDelimited).string(message.uuid);
		if (message.timestamp !== "") writer.tag(4, WireType.LengthDelimited).string(message.timestamp);
		if (message.version !== 0n) writer.tag(5, WireType.Varint).int64(message.version);
		if (message.status !== "") writer.tag(6, WireType.LengthDelimited).string(message.status);
		if (message.statusId !== 0n) writer.tag(7, WireType.Varint).int64(message.statusId);
		for (let i = 0; i < message.acl.length; i++) ACLEntry.internalBinaryWrite(message.acl[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
		if (message.updaterUri !== "") writer.tag(9, WireType.LengthDelimited).string(message.updaterUri);
		if (message.type !== "") writer.tag(10, WireType.LengthDelimited).string(message.type);
		if (message.language !== "") writer.tag(11, WireType.LengthDelimited).string(message.language);
		if (message.oldLanguage !== "") writer.tag(12, WireType.LengthDelimited).string(message.oldLanguage);
		if (message.mainDocument !== "") writer.tag(13, WireType.LengthDelimited).string(message.mainDocument);
		if (message.systemState !== "") writer.tag(14, WireType.LengthDelimited).string(message.systemState);
		if (message.workflowState !== "") writer.tag(15, WireType.LengthDelimited).string(message.workflowState);
		if (message.workflowCheckpoint !== "") writer.tag(16, WireType.LengthDelimited).string(message.workflowCheckpoint);
		if (message.mainDocumentType !== "") writer.tag(17, WireType.LengthDelimited).string(message.mainDocumentType);
		for (let i = 0; i < message.attachedObjects.length; i++) writer.tag(18, WireType.LengthDelimited).string(message.attachedObjects[i]);
		for (let i = 0; i < message.detachedObjects.length; i++) writer.tag(19, WireType.LengthDelimited).string(message.detachedObjects[i]);
		if (message.deleteRecordId !== 0n) writer.tag(20, WireType.Varint).int64(message.deleteRecordId);
		if (message.documentNonce !== "") writer.tag(21, WireType.LengthDelimited).string(message.documentNonce);
		for (let i = 0; i < message.timespans.length; i++) Timespan.internalBinaryWrite(message.timespans[i], writer.tag(22, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.labels.length; i++) writer.tag(23, WireType.LengthDelimited).string(message.labels[i]);
		if (message.schemaGeneration !== 0n) writer.tag(24, WireType.Varint).int64(message.schemaGeneration);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.EventlogItem
*/
const EventlogItem = new EventlogItem$Type();
var Timespan$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.Timespan", [{
			no: 1,
			name: "from",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "to",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.from = "";
		message.to = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.from = reader.string();
					break;
				case 2:
					message.to = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.from !== "") writer.tag(1, WireType.LengthDelimited).string(message.from);
		if (message.to !== "") writer.tag(2, WireType.LengthDelimited).string(message.to);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.Timespan
*/
const Timespan = new Timespan$Type();
var GetStatusRulesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusRulesRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusRulesRequest
*/
const GetStatusRulesRequest = new GetStatusRulesRequest$Type();
var GetStatusRulesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusRulesResponse", [{
			no: 1,
			name: "rules",
			kind: "message",
			repeat: 2,
			T: () => StatusRule
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.rules = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.rules.push(StatusRule.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.rules.length; i++) StatusRule.internalBinaryWrite(message.rules[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusRulesResponse
*/
const GetStatusRulesResponse = new GetStatusRulesResponse$Type();
var GetStatusesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusesRequest", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusesRequest
*/
const GetStatusesRequest = new GetStatusesRequest$Type();
var SetWorkflowRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.SetWorkflowRequest", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "workflow",
			kind: "message",
			T: () => DocumentWorkflow
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.workflow = DocumentWorkflow.internalBinaryRead(reader, reader.uint32(), options, message.workflow);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.workflow) DocumentWorkflow.internalBinaryWrite(message.workflow, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.SetWorkflowRequest
*/
const SetWorkflowRequest = new SetWorkflowRequest$Type();
var DocumentWorkflow$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DocumentWorkflow", [
			{
				no: 1,
				name: "step_zero",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "checkpoint",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "negative_checkpoint",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "steps",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.stepZero = "";
		message.checkpoint = "";
		message.negativeCheckpoint = "";
		message.steps = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.stepZero = reader.string();
					break;
				case 2:
					message.checkpoint = reader.string();
					break;
				case 3:
					message.negativeCheckpoint = reader.string();
					break;
				case 4:
					message.steps.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.stepZero !== "") writer.tag(1, WireType.LengthDelimited).string(message.stepZero);
		if (message.checkpoint !== "") writer.tag(2, WireType.LengthDelimited).string(message.checkpoint);
		if (message.negativeCheckpoint !== "") writer.tag(3, WireType.LengthDelimited).string(message.negativeCheckpoint);
		for (let i = 0; i < message.steps.length; i++) writer.tag(4, WireType.LengthDelimited).string(message.steps[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DocumentWorkflow
*/
const DocumentWorkflow = new DocumentWorkflow$Type();
var SetWorkflowResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.SetWorkflowResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.SetWorkflowResponse
*/
const SetWorkflowResponse = new SetWorkflowResponse$Type();
var GetWorkflowRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetWorkflowRequest", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetWorkflowRequest
*/
const GetWorkflowRequest = new GetWorkflowRequest$Type();
var GetWorkflowResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetWorkflowResponse", [
			{
				no: 1,
				name: "workflow",
				kind: "message",
				T: () => DocumentWorkflow
			},
			{
				no: 2,
				name: "updater_uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "updated",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.updaterUri = "";
		message.updated = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.workflow = DocumentWorkflow.internalBinaryRead(reader, reader.uint32(), options, message.workflow);
					break;
				case 2:
					message.updaterUri = reader.string();
					break;
				case 3:
					message.updated = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.workflow) DocumentWorkflow.internalBinaryWrite(message.workflow, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.updaterUri !== "") writer.tag(2, WireType.LengthDelimited).string(message.updaterUri);
		if (message.updated !== "") writer.tag(3, WireType.LengthDelimited).string(message.updated);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetWorkflowResponse
*/
const GetWorkflowResponse = new GetWorkflowResponse$Type();
var DeleteWorkflowRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteWorkflowRequest", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteWorkflowRequest
*/
const DeleteWorkflowRequest = new DeleteWorkflowRequest$Type();
var DeleteWorkflowResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteWorkflowResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteWorkflowResponse
*/
const DeleteWorkflowResponse = new DeleteWorkflowResponse$Type();
var WorkflowStatus$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.WorkflowStatus", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.WorkflowStatus
*/
const WorkflowStatus = new WorkflowStatus$Type();
var GetStatusesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetStatusesResponse", [{
			no: 1,
			name: "statuses",
			kind: "message",
			repeat: 2,
			T: () => WorkflowStatus
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.statuses = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.statuses.push(WorkflowStatus.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.statuses.length; i++) WorkflowStatus.internalBinaryWrite(message.statuses[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetStatusesResponse
*/
const GetStatusesResponse = new GetStatusesResponse$Type();
var UpdateStatusRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UpdateStatusRequest", [
			{
				no: 1,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "disabled",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		message.name = "";
		message.disabled = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				case 3:
					message.disabled = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		if (message.disabled !== false) writer.tag(3, WireType.Varint).bool(message.disabled);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UpdateStatusRequest
*/
const UpdateStatusRequest = new UpdateStatusRequest$Type();
var UpdateStatusResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UpdateStatusResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UpdateStatusResponse
*/
const UpdateStatusResponse = new UpdateStatusResponse$Type();
var CreateStatusRuleRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.CreateStatusRuleRequest", [{
			no: 1,
			name: "rule",
			kind: "message",
			T: () => StatusRule
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.rule = StatusRule.internalBinaryRead(reader, reader.uint32(), options, message.rule);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.rule) StatusRule.internalBinaryWrite(message.rule, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.CreateStatusRuleRequest
*/
const CreateStatusRuleRequest = new CreateStatusRuleRequest$Type();
var StatusRule$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.StatusRule", [
			{
				no: 1,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "access_rule",
				kind: "scalar",
				T: 8
			},
			{
				no: 5,
				name: "applies_to",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 7,
				name: "expression",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		message.name = "";
		message.description = "";
		message.accessRule = false;
		message.appliesTo = [];
		message.expression = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				case 3:
					message.description = reader.string();
					break;
				case 4:
					message.accessRule = reader.bool();
					break;
				case 5:
					message.appliesTo.push(reader.string());
					break;
				case 7:
					message.expression = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		if (message.description !== "") writer.tag(3, WireType.LengthDelimited).string(message.description);
		if (message.accessRule !== false) writer.tag(4, WireType.Varint).bool(message.accessRule);
		for (let i = 0; i < message.appliesTo.length; i++) writer.tag(5, WireType.LengthDelimited).string(message.appliesTo[i]);
		if (message.expression !== "") writer.tag(7, WireType.LengthDelimited).string(message.expression);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.StatusRule
*/
const StatusRule = new StatusRule$Type();
var CreateStatusRuleResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.CreateStatusRuleResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.CreateStatusRuleResponse
*/
const CreateStatusRuleResponse = new CreateStatusRuleResponse$Type();
var DeleteStatusRuleRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteStatusRuleRequest", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteStatusRuleRequest
*/
const DeleteStatusRuleRequest = new DeleteStatusRuleRequest$Type();
var DeleteStatusRuleResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteStatusRuleResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteStatusRuleResponse
*/
const DeleteStatusRuleResponse = new DeleteStatusRuleResponse$Type();
var GetDocumentRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetDocumentRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "status",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "lock",
				kind: "message",
				T: () => AcquireLock
			},
			{
				no: 5,
				name: "meta_document",
				kind: "enum",
				T: () => ["elephant.repository.GetMetaDoc", GetMetaDoc]
			},
			{
				no: 6,
				name: "meta_document_version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 7,
				name: "subset",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.version = 0n;
		message.status = "";
		message.metaDocument = 0;
		message.metaDocumentVersion = 0n;
		message.subset = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					message.status = reader.string();
					break;
				case 4:
					message.lock = AcquireLock.internalBinaryRead(reader, reader.uint32(), options, message.lock);
					break;
				case 5:
					message.metaDocument = reader.int32();
					break;
				case 6:
					message.metaDocumentVersion = reader.int64().toBigInt();
					break;
				case 7:
					message.subset.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		if (message.status !== "") writer.tag(3, WireType.LengthDelimited).string(message.status);
		if (message.lock) AcquireLock.internalBinaryWrite(message.lock, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		if (message.metaDocument !== 0) writer.tag(5, WireType.Varint).int32(message.metaDocument);
		if (message.metaDocumentVersion !== 0n) writer.tag(6, WireType.Varint).int64(message.metaDocumentVersion);
		for (let i = 0; i < message.subset.length; i++) writer.tag(7, WireType.LengthDelimited).string(message.subset[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetDocumentRequest
*/
const GetDocumentRequest = new GetDocumentRequest$Type();
var GetDocumentResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetDocumentResponse", [
			{
				no: 1,
				name: "document",
				kind: "message",
				T: () => Document
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "status",
				kind: "message",
				T: () => Status
			},
			{
				no: 4,
				name: "meta",
				kind: "message",
				T: () => MetaDocument
			},
			{
				no: 5,
				name: "is_meta_document",
				kind: "scalar",
				T: 8
			},
			{
				no: 6,
				name: "main_document",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "subset",
				kind: "message",
				repeat: 2,
				T: () => ExtractedValues
			},
			{
				no: 8,
				name: "lock",
				kind: "message",
				T: () => LockGrant
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = 0n;
		message.isMetaDocument = false;
		message.mainDocument = "";
		message.subset = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					message.status = Status.internalBinaryRead(reader, reader.uint32(), options, message.status);
					break;
				case 4:
					message.meta = MetaDocument.internalBinaryRead(reader, reader.uint32(), options, message.meta);
					break;
				case 5:
					message.isMetaDocument = reader.bool();
					break;
				case 6:
					message.mainDocument = reader.string();
					break;
				case 7:
					message.subset.push(ExtractedValues.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 8:
					message.lock = LockGrant.internalBinaryRead(reader, reader.uint32(), options, message.lock);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		if (message.status) Status.internalBinaryWrite(message.status, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		if (message.meta) MetaDocument.internalBinaryWrite(message.meta, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		if (message.isMetaDocument !== false) writer.tag(5, WireType.Varint).bool(message.isMetaDocument);
		if (message.mainDocument !== "") writer.tag(6, WireType.LengthDelimited).string(message.mainDocument);
		for (let i = 0; i < message.subset.length; i++) ExtractedValues.internalBinaryWrite(message.subset[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
		if (message.lock) LockGrant.internalBinaryWrite(message.lock, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetDocumentResponse
*/
const GetDocumentResponse = new GetDocumentResponse$Type();
var ExtractedValues$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ExtractedValues", [{
			no: 1,
			name: "extractor",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "values",
			kind: "map",
			K: 9,
			V: {
				kind: "message",
				T: () => ExtractedValue
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.extractor = 0n;
		message.values = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.extractor = reader.int64().toBigInt();
					break;
				case 2:
					this.binaryReadMap2(message.values, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap2(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = ExtractedValue.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.ExtractedValues.values");
			}
		}
		map[key ?? ""] = val ?? ExtractedValue.create();
	}
	internalBinaryWrite(message, writer, options) {
		if (message.extractor !== 0n) writer.tag(1, WireType.Varint).int64(message.extractor);
		for (let k of globalThis.Object.keys(message.values)) {
			writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			ExtractedValue.internalBinaryWrite(message.values[k], writer, options);
			writer.join().join();
		}
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ExtractedValues
*/
const ExtractedValues = new ExtractedValues$Type();
var ExtractedValue$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ExtractedValue", [
			{
				no: 1,
				name: "value",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "block",
				kind: "message",
				T: () => Block
			},
			{
				no: 3,
				name: "annotation",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "role",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.value = "";
		message.annotation = "";
		message.role = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.value = reader.string();
					break;
				case 2:
					message.block = Block.internalBinaryRead(reader, reader.uint32(), options, message.block);
					break;
				case 3:
					message.annotation = reader.string();
					break;
				case 4:
					message.role = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.value !== "") writer.tag(1, WireType.LengthDelimited).string(message.value);
		if (message.block) Block.internalBinaryWrite(message.block, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.annotation !== "") writer.tag(3, WireType.LengthDelimited).string(message.annotation);
		if (message.role !== "") writer.tag(4, WireType.LengthDelimited).string(message.role);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ExtractedValue
*/
const ExtractedValue = new ExtractedValue$Type();
var BulkGetRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.BulkGetRequest", [{
			no: 1,
			name: "documents",
			kind: "message",
			repeat: 2,
			T: () => BulkGetReference
		}, {
			no: 2,
			name: "subset",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.documents = [];
		message.subset = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.documents.push(BulkGetReference.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.subset.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.documents.length; i++) BulkGetReference.internalBinaryWrite(message.documents[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.subset.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.subset[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.BulkGetRequest
*/
const BulkGetRequest = new BulkGetRequest$Type();
var BulkGetReference$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.BulkGetReference", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "version",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.version = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.BulkGetReference
*/
const BulkGetReference = new BulkGetReference$Type();
var BulkGetResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.BulkGetResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => BulkGetItem
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(BulkGetItem.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) BulkGetItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.BulkGetResponse
*/
const BulkGetResponse = new BulkGetResponse$Type();
var BulkGetItem$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.BulkGetItem", [
			{
				no: 1,
				name: "document",
				kind: "message",
				T: () => Document
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "subset",
				kind: "message",
				repeat: 2,
				T: () => ExtractedValues
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = 0n;
		message.uuid = "";
		message.subset = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					message.uuid = reader.string();
					break;
				case 4:
					message.subset.push(ExtractedValues.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		if (message.uuid !== "") writer.tag(3, WireType.LengthDelimited).string(message.uuid);
		for (let i = 0; i < message.subset.length; i++) ExtractedValues.internalBinaryWrite(message.subset[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.BulkGetItem
*/
const BulkGetItem = new BulkGetItem$Type();
var MetaDocument$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.MetaDocument", [{
			no: 1,
			name: "document",
			kind: "message",
			T: () => Document
		}, {
			no: 2,
			name: "version",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.MetaDocument
*/
const MetaDocument = new MetaDocument$Type();
var GetHistoryRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetHistoryRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "before",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "load_statuses",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.before = 0n;
		message.loadStatuses = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.before = reader.int64().toBigInt();
					break;
				case 3:
					message.loadStatuses = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.before !== 0n) writer.tag(2, WireType.Varint).int64(message.before);
		if (message.loadStatuses !== false) writer.tag(3, WireType.Varint).bool(message.loadStatuses);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetHistoryRequest
*/
const GetHistoryRequest = new GetHistoryRequest$Type();
var GetHistoryResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetHistoryResponse", [{
			no: 1,
			name: "versions",
			kind: "message",
			repeat: 2,
			T: () => DocumentVersion
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.versions = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.versions.push(DocumentVersion.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.versions.length; i++) DocumentVersion.internalBinaryWrite(message.versions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetHistoryResponse
*/
const GetHistoryResponse = new GetHistoryResponse$Type();
var DocumentVersion$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DocumentVersion", [
			{
				no: 1,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "creator",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "meta",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 5,
				name: "statuses",
				kind: "map",
				K: 9,
				V: {
					kind: "message",
					T: () => DocumentStatuses
				}
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = 0n;
		message.created = "";
		message.creator = "";
		message.meta = {};
		message.statuses = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.version = reader.int64().toBigInt();
					break;
				case 2:
					message.created = reader.string();
					break;
				case 3:
					message.creator = reader.string();
					break;
				case 4:
					this.binaryReadMap4(message.meta, reader, options);
					break;
				case 5:
					this.binaryReadMap5(message.statuses, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap4(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.DocumentVersion.meta");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	binaryReadMap5(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = DocumentStatuses.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.DocumentVersion.statuses");
			}
		}
		map[key ?? ""] = val ?? DocumentStatuses.create();
	}
	internalBinaryWrite(message, writer, options) {
		if (message.version !== 0n) writer.tag(1, WireType.Varint).int64(message.version);
		if (message.created !== "") writer.tag(2, WireType.LengthDelimited).string(message.created);
		if (message.creator !== "") writer.tag(3, WireType.LengthDelimited).string(message.creator);
		for (let k of globalThis.Object.keys(message.meta)) writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.meta[k]).join();
		for (let k of globalThis.Object.keys(message.statuses)) {
			writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			DocumentStatuses.internalBinaryWrite(message.statuses[k], writer, options);
			writer.join().join();
		}
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DocumentVersion
*/
const DocumentVersion = new DocumentVersion$Type();
var DocumentStatuses$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DocumentStatuses", [{
			no: 5,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => Status
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 5:
					message.items.push(Status.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) Status.internalBinaryWrite(message.items[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DocumentStatuses
*/
const DocumentStatuses = new DocumentStatuses$Type();
var UpdateRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UpdateRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "document",
				kind: "message",
				T: () => Document
			},
			{
				no: 3,
				name: "meta",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 4,
				name: "if_match",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 5,
				name: "status",
				kind: "message",
				repeat: 2,
				T: () => StatusUpdate
			},
			{
				no: 6,
				name: "acl",
				kind: "message",
				repeat: 2,
				T: () => ACLEntry
			},
			{
				no: 7,
				name: "import_directive",
				kind: "message",
				T: () => ImportDirective
			},
			{
				no: 8,
				name: "lockToken",
				kind: "scalar",
				T: 9
			},
			{
				no: 9,
				name: "update_meta_document",
				kind: "scalar",
				T: 8
			},
			{
				no: 10,
				name: "if_workflow_state",
				kind: "scalar",
				T: 9
			},
			{
				no: 11,
				name: "if_status_heads",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 3,
					L: 0
				}
			},
			{
				no: 12,
				name: "attach_objects",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 13,
				name: "detach_objects",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.meta = {};
		message.ifMatch = 0n;
		message.status = [];
		message.acl = [];
		message.lockToken = "";
		message.updateMetaDocument = false;
		message.ifWorkflowState = "";
		message.ifStatusHeads = {};
		message.attachObjects = {};
		message.detachObjects = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				case 3:
					this.binaryReadMap3(message.meta, reader, options);
					break;
				case 4:
					message.ifMatch = reader.int64().toBigInt();
					break;
				case 5:
					message.status.push(StatusUpdate.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 6:
					message.acl.push(ACLEntry.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 7:
					message.importDirective = ImportDirective.internalBinaryRead(reader, reader.uint32(), options, message.importDirective);
					break;
				case 8:
					message.lockToken = reader.string();
					break;
				case 9:
					message.updateMetaDocument = reader.bool();
					break;
				case 10:
					message.ifWorkflowState = reader.string();
					break;
				case 11:
					this.binaryReadMap11(message.ifStatusHeads, reader, options);
					break;
				case 12:
					this.binaryReadMap12(message.attachObjects, reader, options);
					break;
				case 13:
					message.detachObjects.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap3(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.UpdateRequest.meta");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	binaryReadMap11(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.int64().toBigInt();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.UpdateRequest.if_status_heads");
			}
		}
		map[key ?? ""] = val ?? 0n;
	}
	binaryReadMap12(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.UpdateRequest.attach_objects");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		for (let k of globalThis.Object.keys(message.meta)) writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.meta[k]).join();
		if (message.ifMatch !== 0n) writer.tag(4, WireType.Varint).int64(message.ifMatch);
		for (let i = 0; i < message.status.length; i++) StatusUpdate.internalBinaryWrite(message.status[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.acl.length; i++) ACLEntry.internalBinaryWrite(message.acl[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		if (message.importDirective) ImportDirective.internalBinaryWrite(message.importDirective, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
		if (message.lockToken !== "") writer.tag(8, WireType.LengthDelimited).string(message.lockToken);
		if (message.updateMetaDocument !== false) writer.tag(9, WireType.Varint).bool(message.updateMetaDocument);
		if (message.ifWorkflowState !== "") writer.tag(10, WireType.LengthDelimited).string(message.ifWorkflowState);
		for (let k of globalThis.Object.keys(message.ifStatusHeads)) writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).int64(message.ifStatusHeads[k]).join();
		for (let k of globalThis.Object.keys(message.attachObjects)) writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.attachObjects[k]).join();
		for (let i = 0; i < message.detachObjects.length; i++) writer.tag(13, WireType.LengthDelimited).string(message.detachObjects[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UpdateRequest
*/
const UpdateRequest = new UpdateRequest$Type();
var ImportDirective$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ImportDirective", [{
			no: 1,
			name: "originally_created",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "original_creator",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.originallyCreated = "";
		message.originalCreator = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.originallyCreated = reader.string();
					break;
				case 2:
					message.originalCreator = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.originallyCreated !== "") writer.tag(1, WireType.LengthDelimited).string(message.originallyCreated);
		if (message.originalCreator !== "") writer.tag(2, WireType.LengthDelimited).string(message.originalCreator);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ImportDirective
*/
const ImportDirective = new ImportDirective$Type();
var UpdateResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UpdateResponse", [{
			no: 1,
			name: "version",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "uuid",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = 0n;
		message.uuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.version = reader.int64().toBigInt();
					break;
				case 2:
					message.uuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.version !== 0n) writer.tag(1, WireType.Varint).int64(message.version);
		if (message.uuid !== "") writer.tag(2, WireType.LengthDelimited).string(message.uuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UpdateResponse
*/
const UpdateResponse = new UpdateResponse$Type();
var BulkUpdateRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.BulkUpdateRequest", [{
			no: 1,
			name: "updates",
			kind: "message",
			repeat: 2,
			T: () => UpdateRequest
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.updates = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.updates.push(UpdateRequest.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.updates.length; i++) UpdateRequest.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.BulkUpdateRequest
*/
const BulkUpdateRequest = new BulkUpdateRequest$Type();
var BulkUpdateResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.BulkUpdateResponse", [{
			no: 1,
			name: "updates",
			kind: "message",
			repeat: 2,
			T: () => UpdateResponse
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.updates = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.updates.push(UpdateResponse.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.updates.length; i++) UpdateResponse.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.BulkUpdateResponse
*/
const BulkUpdateResponse = new BulkUpdateResponse$Type();
var ValidateRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ValidateRequest", [{
			no: 1,
			name: "document",
			kind: "message",
			T: () => Document
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ValidateRequest
*/
const ValidateRequest = new ValidateRequest$Type();
var ValidateResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ValidateResponse", [{
			no: 1,
			name: "errors",
			kind: "message",
			repeat: 2,
			T: () => ValidationResult
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.errors = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.errors.push(ValidationResult.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.errors.length; i++) ValidationResult.internalBinaryWrite(message.errors[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ValidateResponse
*/
const ValidateResponse = new ValidateResponse$Type();
var PruneRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.PruneRequest", [{
			no: 1,
			name: "document",
			kind: "message",
			T: () => Document
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.PruneRequest
*/
const PruneRequest = new PruneRequest$Type();
var PruneResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.PruneResponse", [{
			no: 1,
			name: "document",
			kind: "message",
			T: () => Document
		}, {
			no: 2,
			name: "errors",
			kind: "message",
			repeat: 2,
			T: () => ValidationResult
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.errors = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				case 2:
					message.errors.push(ValidationResult.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.errors.length; i++) ValidationResult.internalBinaryWrite(message.errors[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.PruneResponse
*/
const PruneResponse = new PruneResponse$Type();
var ValidationResult$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ValidationResult", [{
			no: 1,
			name: "entity",
			kind: "message",
			repeat: 2,
			T: () => EntityRef
		}, {
			no: 2,
			name: "error",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.entity = [];
		message.error = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.entity.push(EntityRef.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.error = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.entity.length; i++) EntityRef.internalBinaryWrite(message.entity[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.error !== "") writer.tag(2, WireType.LengthDelimited).string(message.error);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ValidationResult
*/
const ValidationResult = new ValidationResult$Type();
var EntityRef$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.EntityRef", [
			{
				no: 1,
				name: "ref_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "kind",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "index",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 4,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "rel",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.refType = "";
		message.kind = "";
		message.index = 0n;
		message.name = "";
		message.type = "";
		message.rel = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.refType = reader.string();
					break;
				case 2:
					message.kind = reader.string();
					break;
				case 3:
					message.index = reader.int64().toBigInt();
					break;
				case 4:
					message.name = reader.string();
					break;
				case 5:
					message.type = reader.string();
					break;
				case 6:
					message.rel = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.refType !== "") writer.tag(1, WireType.LengthDelimited).string(message.refType);
		if (message.kind !== "") writer.tag(2, WireType.LengthDelimited).string(message.kind);
		if (message.index !== 0n) writer.tag(3, WireType.Varint).int64(message.index);
		if (message.name !== "") writer.tag(4, WireType.LengthDelimited).string(message.name);
		if (message.type !== "") writer.tag(5, WireType.LengthDelimited).string(message.type);
		if (message.rel !== "") writer.tag(6, WireType.LengthDelimited).string(message.rel);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.EntityRef
*/
const EntityRef = new EntityRef$Type();
var StatusUpdate$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.StatusUpdate", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "meta",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 4,
				name: "if_match",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = 0n;
		message.meta = {};
		message.ifMatch = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					this.binaryReadMap3(message.meta, reader, options);
					break;
				case 4:
					message.ifMatch = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap3(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.StatusUpdate.meta");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		for (let k of globalThis.Object.keys(message.meta)) writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.meta[k]).join();
		if (message.ifMatch !== 0n) writer.tag(4, WireType.Varint).int64(message.ifMatch);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.StatusUpdate
*/
const StatusUpdate = new StatusUpdate$Type();
var UpdatePermissionsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UpdatePermissionsRequest", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "list",
			kind: "message",
			repeat: 2,
			T: () => ACLEntry
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.list = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.list.push(ACLEntry.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		for (let i = 0; i < message.list.length; i++) ACLEntry.internalBinaryWrite(message.list[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UpdatePermissionsRequest
*/
const UpdatePermissionsRequest = new UpdatePermissionsRequest$Type();
var UpdatePermissionsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UpdatePermissionsResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UpdatePermissionsResponse
*/
const UpdatePermissionsResponse = new UpdatePermissionsResponse$Type();
var DeleteDocumentRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteDocumentRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "meta",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 3,
				name: "if_match",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 8,
				name: "lockToken",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.meta = {};
		message.ifMatch = 0n;
		message.lockToken = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					this.binaryReadMap2(message.meta, reader, options);
					break;
				case 3:
					message.ifMatch = reader.int64().toBigInt();
					break;
				case 8:
					message.lockToken = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap2(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.DeleteDocumentRequest.meta");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		for (let k of globalThis.Object.keys(message.meta)) writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.meta[k]).join();
		if (message.ifMatch !== 0n) writer.tag(3, WireType.Varint).int64(message.ifMatch);
		if (message.lockToken !== "") writer.tag(8, WireType.LengthDelimited).string(message.lockToken);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteDocumentRequest
*/
const DeleteDocumentRequest = new DeleteDocumentRequest$Type();
var DeleteDocumentResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteDocumentResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteDocumentResponse
*/
const DeleteDocumentResponse = new DeleteDocumentResponse$Type();
var RestoreRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RestoreRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "delete_record_id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "acl",
				kind: "message",
				repeat: 2,
				T: () => ACLEntry
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.deleteRecordId = 0n;
		message.acl = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.deleteRecordId = reader.int64().toBigInt();
					break;
				case 3:
					message.acl.push(ACLEntry.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.deleteRecordId !== 0n) writer.tag(2, WireType.Varint).int64(message.deleteRecordId);
		for (let i = 0; i < message.acl.length; i++) ACLEntry.internalBinaryWrite(message.acl[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RestoreRequest
*/
const RestoreRequest = new RestoreRequest$Type();
var RestoreResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RestoreResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RestoreResponse
*/
const RestoreResponse = new RestoreResponse$Type();
var PurgeRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.PurgeRequest", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "delete_record_id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.deleteRecordId = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.deleteRecordId = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.deleteRecordId !== 0n) writer.tag(2, WireType.Varint).int64(message.deleteRecordId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.PurgeRequest
*/
const PurgeRequest = new PurgeRequest$Type();
var PurgeResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.PurgeResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.PurgeResponse
*/
const PurgeResponse = new PurgeResponse$Type();
var ListDeletedRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ListDeletedRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "before_id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "before_date",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "timezone",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.beforeId = 0n;
		message.beforeDate = "";
		message.timezone = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.beforeId = reader.int64().toBigInt();
					break;
				case 3:
					message.beforeDate = reader.string();
					break;
				case 4:
					message.timezone = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.beforeId !== 0n) writer.tag(2, WireType.Varint).int64(message.beforeId);
		if (message.beforeDate !== "") writer.tag(3, WireType.LengthDelimited).string(message.beforeDate);
		if (message.timezone !== "") writer.tag(4, WireType.LengthDelimited).string(message.timezone);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ListDeletedRequest
*/
const ListDeletedRequest = new ListDeletedRequest$Type();
var ListDeletedResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ListDeletedResponse", [{
			no: 1,
			name: "deletes",
			kind: "message",
			repeat: 2,
			T: () => DeleteRecord
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.deletes = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.deletes.push(DeleteRecord.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.deletes.length; i++) DeleteRecord.internalBinaryWrite(message.deletes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ListDeletedResponse
*/
const ListDeletedResponse = new ListDeletedResponse$Type();
var DeleteRecord$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteRecord", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 6,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "creator",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "meta",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 9,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "finalised",
				kind: "scalar",
				T: 9
			},
			{
				no: 11,
				name: "purged",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.uuid = "";
		message.uri = "";
		message.type = "";
		message.version = 0n;
		message.created = "";
		message.creator = "";
		message.meta = {};
		message.language = "";
		message.finalised = "";
		message.purged = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.uuid = reader.string();
					break;
				case 3:
					message.uri = reader.string();
					break;
				case 4:
					message.type = reader.string();
					break;
				case 5:
					message.version = reader.int64().toBigInt();
					break;
				case 6:
					message.created = reader.string();
					break;
				case 7:
					message.creator = reader.string();
					break;
				case 8:
					this.binaryReadMap8(message.meta, reader, options);
					break;
				case 9:
					message.language = reader.string();
					break;
				case 10:
					message.finalised = reader.string();
					break;
				case 11:
					message.purged = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap8(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.DeleteRecord.meta");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.uuid !== "") writer.tag(2, WireType.LengthDelimited).string(message.uuid);
		if (message.uri !== "") writer.tag(3, WireType.LengthDelimited).string(message.uri);
		if (message.type !== "") writer.tag(4, WireType.LengthDelimited).string(message.type);
		if (message.version !== 0n) writer.tag(5, WireType.Varint).int64(message.version);
		if (message.created !== "") writer.tag(6, WireType.LengthDelimited).string(message.created);
		if (message.creator !== "") writer.tag(7, WireType.LengthDelimited).string(message.creator);
		for (let k of globalThis.Object.keys(message.meta)) writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.meta[k]).join();
		if (message.language !== "") writer.tag(9, WireType.LengthDelimited).string(message.language);
		if (message.finalised !== "") writer.tag(10, WireType.LengthDelimited).string(message.finalised);
		if (message.purged !== "") writer.tag(11, WireType.LengthDelimited).string(message.purged);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteRecord
*/
const DeleteRecord = new DeleteRecord$Type();
var GetMetaRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMetaRequest", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMetaRequest
*/
const GetMetaRequest = new GetMetaRequest$Type();
var GetMetaResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMetaResponse", [{
			no: 1,
			name: "meta",
			kind: "message",
			T: () => DocumentMeta
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.meta = DocumentMeta.internalBinaryRead(reader, reader.uint32(), options, message.meta);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.meta) DocumentMeta.internalBinaryWrite(message.meta, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMetaResponse
*/
const GetMetaResponse = new GetMetaResponse$Type();
var DocumentMeta$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DocumentMeta", [
			{
				no: 1,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "modified",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "current_version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 4,
				name: "heads",
				kind: "map",
				K: 9,
				V: {
					kind: "message",
					T: () => Status
				}
			},
			{
				no: 5,
				name: "acl",
				kind: "message",
				repeat: 2,
				T: () => ACLEntry
			},
			{
				no: 6,
				name: "lock",
				kind: "message",
				T: () => Lock
			},
			{
				no: 7,
				name: "is_meta_document",
				kind: "scalar",
				T: 8
			},
			{
				no: 8,
				name: "main_document",
				kind: "scalar",
				T: 9
			},
			{
				no: 9,
				name: "workflow_state",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "workflow_checkpoint",
				kind: "scalar",
				T: 9
			},
			{
				no: 11,
				name: "creator_uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 12,
				name: "updater_uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 13,
				name: "attachments",
				kind: "message",
				repeat: 2,
				T: () => AttachmentRef
			},
			{
				no: 14,
				name: "nonce",
				kind: "scalar",
				T: 9
			},
			{
				no: 15,
				name: "type",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.created = "";
		message.modified = "";
		message.currentVersion = 0n;
		message.heads = {};
		message.acl = [];
		message.isMetaDocument = false;
		message.mainDocument = "";
		message.workflowState = "";
		message.workflowCheckpoint = "";
		message.creatorUri = "";
		message.updaterUri = "";
		message.attachments = [];
		message.nonce = "";
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.created = reader.string();
					break;
				case 2:
					message.modified = reader.string();
					break;
				case 3:
					message.currentVersion = reader.int64().toBigInt();
					break;
				case 4:
					this.binaryReadMap4(message.heads, reader, options);
					break;
				case 5:
					message.acl.push(ACLEntry.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 6:
					message.lock = Lock.internalBinaryRead(reader, reader.uint32(), options, message.lock);
					break;
				case 7:
					message.isMetaDocument = reader.bool();
					break;
				case 8:
					message.mainDocument = reader.string();
					break;
				case 9:
					message.workflowState = reader.string();
					break;
				case 10:
					message.workflowCheckpoint = reader.string();
					break;
				case 11:
					message.creatorUri = reader.string();
					break;
				case 12:
					message.updaterUri = reader.string();
					break;
				case 13:
					message.attachments.push(AttachmentRef.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 14:
					message.nonce = reader.string();
					break;
				case 15:
					message.type = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap4(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = Status.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.DocumentMeta.heads");
			}
		}
		map[key ?? ""] = val ?? Status.create();
	}
	internalBinaryWrite(message, writer, options) {
		if (message.created !== "") writer.tag(1, WireType.LengthDelimited).string(message.created);
		if (message.modified !== "") writer.tag(2, WireType.LengthDelimited).string(message.modified);
		if (message.currentVersion !== 0n) writer.tag(3, WireType.Varint).int64(message.currentVersion);
		for (let k of globalThis.Object.keys(message.heads)) {
			writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			Status.internalBinaryWrite(message.heads[k], writer, options);
			writer.join().join();
		}
		for (let i = 0; i < message.acl.length; i++) ACLEntry.internalBinaryWrite(message.acl[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		if (message.lock) Lock.internalBinaryWrite(message.lock, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		if (message.isMetaDocument !== false) writer.tag(7, WireType.Varint).bool(message.isMetaDocument);
		if (message.mainDocument !== "") writer.tag(8, WireType.LengthDelimited).string(message.mainDocument);
		if (message.workflowState !== "") writer.tag(9, WireType.LengthDelimited).string(message.workflowState);
		if (message.workflowCheckpoint !== "") writer.tag(10, WireType.LengthDelimited).string(message.workflowCheckpoint);
		if (message.creatorUri !== "") writer.tag(11, WireType.LengthDelimited).string(message.creatorUri);
		if (message.updaterUri !== "") writer.tag(12, WireType.LengthDelimited).string(message.updaterUri);
		for (let i = 0; i < message.attachments.length; i++) AttachmentRef.internalBinaryWrite(message.attachments[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
		if (message.nonce !== "") writer.tag(14, WireType.LengthDelimited).string(message.nonce);
		if (message.type !== "") writer.tag(15, WireType.LengthDelimited).string(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DocumentMeta
*/
const DocumentMeta = new DocumentMeta$Type();
var AttachmentRef$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.AttachmentRef", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "version",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.AttachmentRef
*/
const AttachmentRef = new AttachmentRef$Type();
var Status$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.Status", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "creator",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "meta",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 6,
				name: "meta_doc_version",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.version = 0n;
		message.creator = "";
		message.created = "";
		message.meta = {};
		message.metaDocVersion = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					message.creator = reader.string();
					break;
				case 4:
					message.created = reader.string();
					break;
				case 5:
					this.binaryReadMap5(message.meta, reader, options);
					break;
				case 6:
					message.metaDocVersion = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap5(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.Status.meta");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		if (message.creator !== "") writer.tag(3, WireType.LengthDelimited).string(message.creator);
		if (message.created !== "") writer.tag(4, WireType.LengthDelimited).string(message.created);
		for (let k of globalThis.Object.keys(message.meta)) writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.meta[k]).join();
		if (message.metaDocVersion !== 0n) writer.tag(6, WireType.Varint).int64(message.metaDocVersion);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.Status
*/
const Status = new Status$Type();
var ACLEntry$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ACLEntry", [{
			no: 1,
			name: "uri",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "permissions",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uri = "";
		message.permissions = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uri = reader.string();
					break;
				case 2:
					message.permissions.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uri !== "") writer.tag(1, WireType.LengthDelimited).string(message.uri);
		for (let i = 0; i < message.permissions.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.permissions[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ACLEntry
*/
const ACLEntry = new ACLEntry$Type();
var Lock$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.Lock", [
			{
				no: 1,
				name: "token",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "expires",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "app",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "comment",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "exclusivity",
				kind: "enum",
				T: () => ["elephant.repository.LockExclusivity", LockExclusivity]
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.token = "";
		message.uri = "";
		message.created = "";
		message.expires = "";
		message.app = "";
		message.comment = "";
		message.exclusivity = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.token = reader.string();
					break;
				case 2:
					message.uri = reader.string();
					break;
				case 3:
					message.created = reader.string();
					break;
				case 4:
					message.expires = reader.string();
					break;
				case 5:
					message.app = reader.string();
					break;
				case 6:
					message.comment = reader.string();
					break;
				case 7:
					message.exclusivity = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
		if (message.uri !== "") writer.tag(2, WireType.LengthDelimited).string(message.uri);
		if (message.created !== "") writer.tag(3, WireType.LengthDelimited).string(message.created);
		if (message.expires !== "") writer.tag(4, WireType.LengthDelimited).string(message.expires);
		if (message.app !== "") writer.tag(5, WireType.LengthDelimited).string(message.app);
		if (message.comment !== "") writer.tag(6, WireType.LengthDelimited).string(message.comment);
		if (message.exclusivity !== 0) writer.tag(7, WireType.Varint).int32(message.exclusivity);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.Lock
*/
const Lock = new Lock$Type();
var RegisterMetaTypeRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterMetaTypeRequest", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "exclusive",
			kind: "scalar",
			T: 8
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		message.exclusive = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.exclusive = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.exclusive !== false) writer.tag(2, WireType.Varint).bool(message.exclusive);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterMetaTypeRequest
*/
const RegisterMetaTypeRequest = new RegisterMetaTypeRequest$Type();
var RegisterMetaTypeResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterMetaTypeResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterMetaTypeResponse
*/
const RegisterMetaTypeResponse = new RegisterMetaTypeResponse$Type();
var RegisterMetaTypeUseRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterMetaTypeUseRequest", [{
			no: 1,
			name: "main_type",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "meta_type",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.mainType = "";
		message.metaType = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.mainType = reader.string();
					break;
				case 2:
					message.metaType = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.mainType !== "") writer.tag(1, WireType.LengthDelimited).string(message.mainType);
		if (message.metaType !== "") writer.tag(2, WireType.LengthDelimited).string(message.metaType);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterMetaTypeUseRequest
*/
const RegisterMetaTypeUseRequest = new RegisterMetaTypeUseRequest$Type();
var RegisterMetaTypeUseResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterMetaTypeUseResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterMetaTypeUseResponse
*/
const RegisterMetaTypeUseResponse = new RegisterMetaTypeUseResponse$Type();
var GetMetaTypesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMetaTypesRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMetaTypesRequest
*/
const GetMetaTypesRequest = new GetMetaTypesRequest$Type();
var GetMetaTypesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMetaTypesResponse", [{
			no: 1,
			name: "types",
			kind: "message",
			repeat: 2,
			T: () => MetaTypeInfo
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.types = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.types.push(MetaTypeInfo.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.types.length; i++) MetaTypeInfo.internalBinaryWrite(message.types[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMetaTypesResponse
*/
const GetMetaTypesResponse = new GetMetaTypesResponse$Type();
var GetDocumentTypesRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetDocumentTypesRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetDocumentTypesRequest
*/
const GetDocumentTypesRequest = new GetDocumentTypesRequest$Type();
var GetDocumentTypesResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetDocumentTypesResponse", [{
			no: 1,
			name: "types",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.types = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.types.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.types.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.types[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetDocumentTypesResponse
*/
const GetDocumentTypesResponse = new GetDocumentTypesResponse$Type();
var MetaTypeInfo$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.MetaTypeInfo", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "used_by",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.usedBy = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.usedBy.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		for (let i = 0; i < message.usedBy.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.usedBy[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.MetaTypeInfo
*/
const MetaTypeInfo = new MetaTypeInfo$Type();
var RegisterGenerationRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterGenerationRequest", [
			{
				no: 1,
				name: "schemas",
				kind: "message",
				repeat: 2,
				T: () => Schema
			},
			{
				no: 2,
				name: "activation",
				kind: "enum",
				T: () => ["elephant.repository.SchemaActivation", SchemaActivation]
			},
			{
				no: 3,
				name: "exemplars",
				kind: "message",
				repeat: 2,
				T: () => Document
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.schemas = [];
		message.activation = 0;
		message.exemplars = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.schemas.push(Schema.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.activation = reader.int32();
					break;
				case 3:
					message.exemplars.push(Document.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.schemas.length; i++) Schema.internalBinaryWrite(message.schemas[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.activation !== 0) writer.tag(2, WireType.Varint).int32(message.activation);
		for (let i = 0; i < message.exemplars.length; i++) Document.internalBinaryWrite(message.exemplars[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterGenerationRequest
*/
const RegisterGenerationRequest = new RegisterGenerationRequest$Type();
var RegisterGenerationResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterGenerationResponse", [{
			no: 1,
			name: "generation_id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.generationId = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.generationId = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.generationId !== 0n) writer.tag(1, WireType.Varint).int64(message.generationId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterGenerationResponse
*/
const RegisterGenerationResponse = new RegisterGenerationResponse$Type();
var SetActiveSchemasRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.SetActiveSchemasRequest", [{
			no: 1,
			name: "generation_id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "activation",
			kind: "enum",
			T: () => ["elephant.repository.SchemaActivation", SchemaActivation]
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.generationId = 0n;
		message.activation = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.generationId = reader.int64().toBigInt();
					break;
				case 2:
					message.activation = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.generationId !== 0n) writer.tag(1, WireType.Varint).int64(message.generationId);
		if (message.activation !== 0) writer.tag(2, WireType.Varint).int32(message.activation);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.SetActiveSchemasRequest
*/
const SetActiveSchemasRequest = new SetActiveSchemasRequest$Type();
var SetActiveSchemasResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.SetActiveSchemasResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.SetActiveSchemasResponse
*/
const SetActiveSchemasResponse = new SetActiveSchemasResponse$Type();
var ListSchemaGenerationsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ListSchemaGenerationsRequest", [{
			no: 1,
			name: "before",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.before = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.before = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.before !== 0n) writer.tag(1, WireType.Varint).int64(message.before);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ListSchemaGenerationsRequest
*/
const ListSchemaGenerationsRequest = new ListSchemaGenerationsRequest$Type();
var ListSchemaGenerationsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ListSchemaGenerationsResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => SchemaGeneration
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(SchemaGeneration.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) SchemaGeneration.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ListSchemaGenerationsResponse
*/
const ListSchemaGenerationsResponse = new ListSchemaGenerationsResponse$Type();
var SchemaGeneration$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.SchemaGeneration", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "status",
				kind: "enum",
				T: () => ["elephant.repository.SchemaActivation", SchemaActivation]
			},
			{
				no: 3,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "activated",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "deactivated",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "schemas",
				kind: "message",
				repeat: 2,
				T: () => SchemaReference
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.status = 0;
		message.created = "";
		message.activated = "";
		message.deactivated = "";
		message.schemas = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.status = reader.int32();
					break;
				case 3:
					message.created = reader.string();
					break;
				case 4:
					message.activated = reader.string();
					break;
				case 5:
					message.deactivated = reader.string();
					break;
				case 6:
					message.schemas.push(SchemaReference.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.status !== 0) writer.tag(2, WireType.Varint).int32(message.status);
		if (message.created !== "") writer.tag(3, WireType.LengthDelimited).string(message.created);
		if (message.activated !== "") writer.tag(4, WireType.LengthDelimited).string(message.activated);
		if (message.deactivated !== "") writer.tag(5, WireType.LengthDelimited).string(message.deactivated);
		for (let i = 0; i < message.schemas.length; i++) SchemaReference.internalBinaryWrite(message.schemas[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.SchemaGeneration
*/
const SchemaGeneration = new SchemaGeneration$Type();
var GetExemplarsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetExemplarsRequest", [{
			no: 1,
			name: "generation_id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "known",
			kind: "map",
			K: 9,
			V: {
				kind: "scalar",
				T: 9
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.generationId = 0n;
		message.known = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.generationId = reader.int64().toBigInt();
					break;
				case 2:
					this.binaryReadMap2(message.known, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap2(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.GetExemplarsRequest.known");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.generationId !== 0n) writer.tag(1, WireType.Varint).int64(message.generationId);
		for (let k of globalThis.Object.keys(message.known)) writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.known[k]).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetExemplarsRequest
*/
const GetExemplarsRequest = new GetExemplarsRequest$Type();
var GetExemplarsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetExemplarsResponse", [{
			no: 1,
			name: "exemplars",
			kind: "message",
			repeat: 2,
			T: () => Exemplar
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.exemplars = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.exemplars.push(Exemplar.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.exemplars.length; i++) Exemplar.internalBinaryWrite(message.exemplars[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetExemplarsResponse
*/
const GetExemplarsResponse = new GetExemplarsResponse$Type();
var Exemplar$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.Exemplar", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "document",
				kind: "message",
				T: () => Document
			},
			{
				no: 3,
				name: "version_hash",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.versionHash = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				case 3:
					message.versionHash = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.versionHash !== "") writer.tag(3, WireType.LengthDelimited).string(message.versionHash);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.Exemplar
*/
const Exemplar = new Exemplar$Type();
var GetSchemaRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetSchemaRequest", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "version",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== "") writer.tag(2, WireType.LengthDelimited).string(message.version);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetSchemaRequest
*/
const GetSchemaRequest = new GetSchemaRequest$Type();
var GetSchemaResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetSchemaResponse", [{
			no: 1,
			name: "version",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "spec",
			kind: "scalar",
			T: 12
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = "";
		message.spec = /* @__PURE__ */ new Uint8Array(0);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.version = reader.string();
					break;
				case 2:
					message.spec = reader.bytes();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.version !== "") writer.tag(1, WireType.LengthDelimited).string(message.version);
		if (message.spec.length) writer.tag(2, WireType.LengthDelimited).bytes(message.spec);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetSchemaResponse
*/
const GetSchemaResponse = new GetSchemaResponse$Type();
var GetAllActiveSchemasRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetAllActiveSchemasRequest", [
			{
				no: 1,
				name: "wait_seconds",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "known",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 3,
				name: "only_changed",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.waitSeconds = 0n;
		message.known = {};
		message.onlyChanged = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.waitSeconds = reader.int64().toBigInt();
					break;
				case 2:
					this.binaryReadMap2(message.known, reader, options);
					break;
				case 3:
					message.onlyChanged = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap2(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.GetAllActiveSchemasRequest.known");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.waitSeconds !== 0n) writer.tag(1, WireType.Varint).int64(message.waitSeconds);
		for (let k of globalThis.Object.keys(message.known)) writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.known[k]).join();
		if (message.onlyChanged !== false) writer.tag(3, WireType.Varint).bool(message.onlyChanged);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetAllActiveSchemasRequest
*/
const GetAllActiveSchemasRequest = new GetAllActiveSchemasRequest$Type();
var GetAllActiveSchemasResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetAllActiveSchemasResponse", [
			{
				no: 1,
				name: "schemas",
				kind: "message",
				repeat: 2,
				T: () => Schema
			},
			{
				no: 2,
				name: "unchanged",
				kind: "scalar",
				T: 8
			},
			{
				no: 3,
				name: "removed",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 4,
				name: "generation_id",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.schemas = [];
		message.unchanged = false;
		message.removed = [];
		message.generationId = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.schemas.push(Schema.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.unchanged = reader.bool();
					break;
				case 3:
					message.removed.push(reader.string());
					break;
				case 4:
					message.generationId = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.schemas.length; i++) Schema.internalBinaryWrite(message.schemas[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.unchanged !== false) writer.tag(2, WireType.Varint).bool(message.unchanged);
		for (let i = 0; i < message.removed.length; i++) writer.tag(3, WireType.LengthDelimited).string(message.removed[i]);
		if (message.generationId !== 0n) writer.tag(4, WireType.Varint).int64(message.generationId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetAllActiveSchemasResponse
*/
const GetAllActiveSchemasResponse = new GetAllActiveSchemasResponse$Type();
var ListActiveSchemasRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ListActiveSchemasRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ListActiveSchemasRequest
*/
const ListActiveSchemasRequest = new ListActiveSchemasRequest$Type();
var ListActiveSchemasResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ListActiveSchemasResponse", [{
			no: 1,
			name: "schemas",
			kind: "message",
			repeat: 2,
			T: () => Schema
		}, {
			no: 2,
			name: "generation_id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.schemas = [];
		message.generationId = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.schemas.push(Schema.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.generationId = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.schemas.length; i++) Schema.internalBinaryWrite(message.schemas[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.generationId !== 0n) writer.tag(2, WireType.Varint).int64(message.generationId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ListActiveSchemasResponse
*/
const ListActiveSchemasResponse = new ListActiveSchemasResponse$Type();
var SchemaReference$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.SchemaReference", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "version",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== "") writer.tag(2, WireType.LengthDelimited).string(message.version);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.SchemaReference
*/
const SchemaReference = new SchemaReference$Type();
var Schema$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.Schema", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "spec",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = "";
		message.spec = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.string();
					break;
				case 3:
					message.spec = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== "") writer.tag(2, WireType.LengthDelimited).string(message.version);
		if (message.spec !== "") writer.tag(3, WireType.LengthDelimited).string(message.spec);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.Schema
*/
const Schema = new Schema$Type();
var GetDeprecationsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetDeprecationsRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetDeprecationsRequest
*/
const GetDeprecationsRequest = new GetDeprecationsRequest$Type();
var Deprecation$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.Deprecation", [{
			no: 1,
			name: "label",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "enforced",
			kind: "scalar",
			T: 8
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.label = "";
		message.enforced = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.label = reader.string();
					break;
				case 2:
					message.enforced = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.label !== "") writer.tag(1, WireType.LengthDelimited).string(message.label);
		if (message.enforced !== false) writer.tag(2, WireType.Varint).bool(message.enforced);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.Deprecation
*/
const Deprecation = new Deprecation$Type();
var GetDeprecationsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetDeprecationsResponse", [{
			no: 1,
			name: "deprecations",
			kind: "message",
			repeat: 2,
			T: () => Deprecation
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.deprecations = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.deprecations.push(Deprecation.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.deprecations.length; i++) Deprecation.internalBinaryWrite(message.deprecations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetDeprecationsResponse
*/
const GetDeprecationsResponse = new GetDeprecationsResponse$Type();
var UpdateDeprecationRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UpdateDeprecationRequest", [{
			no: 1,
			name: "deprecation",
			kind: "message",
			T: () => Deprecation
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.deprecation = Deprecation.internalBinaryRead(reader, reader.uint32(), options, message.deprecation);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.deprecation) Deprecation.internalBinaryWrite(message.deprecation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UpdateDeprecationRequest
*/
const UpdateDeprecationRequest = new UpdateDeprecationRequest$Type();
var UpdateDeprecationResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UpdateDeprecationResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UpdateDeprecationResponse
*/
const UpdateDeprecationResponse = new UpdateDeprecationResponse$Type();
var RegisterMetricKindRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterMetricKindRequest", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "aggregation",
			kind: "enum",
			T: () => ["elephant.repository.MetricAggregation", MetricAggregation]
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.aggregation = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.aggregation = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.aggregation !== 0) writer.tag(2, WireType.Varint).int32(message.aggregation);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterMetricKindRequest
*/
const RegisterMetricKindRequest = new RegisterMetricKindRequest$Type();
var RegisterMetricKindResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterMetricKindResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterMetricKindResponse
*/
const RegisterMetricKindResponse = new RegisterMetricKindResponse$Type();
var DeleteMetricKindRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteMetricKindRequest", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteMetricKindRequest
*/
const DeleteMetricKindRequest = new DeleteMetricKindRequest$Type();
var DeleteMetricKindResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeleteMetricKindResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeleteMetricKindResponse
*/
const DeleteMetricKindResponse = new DeleteMetricKindResponse$Type();
var GetMetricKindsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMetricKindsRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMetricKindsRequest
*/
const GetMetricKindsRequest = new GetMetricKindsRequest$Type();
var GetMetricKindsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMetricKindsResponse", [{
			no: 1,
			name: "kinds",
			kind: "message",
			repeat: 2,
			T: () => MetricKind
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.kinds = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.kinds.push(MetricKind.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.kinds.length; i++) MetricKind.internalBinaryWrite(message.kinds[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMetricKindsResponse
*/
const GetMetricKindsResponse = new GetMetricKindsResponse$Type();
var MetricKind$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.MetricKind", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "aggregation",
			kind: "enum",
			T: () => ["elephant.repository.MetricAggregation", MetricAggregation]
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.aggregation = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.aggregation = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.aggregation !== 0) writer.tag(2, WireType.Varint).int32(message.aggregation);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.MetricKind
*/
const MetricKind = new MetricKind$Type();
var RegisterMetricRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterMetricRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "kind",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "label",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "value",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.kind = "";
		message.label = "";
		message.value = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.kind = reader.string();
					break;
				case 3:
					message.label = reader.string();
					break;
				case 5:
					message.value = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.kind !== "") writer.tag(2, WireType.LengthDelimited).string(message.kind);
		if (message.label !== "") writer.tag(3, WireType.LengthDelimited).string(message.label);
		if (message.value !== 0n) writer.tag(5, WireType.Varint).int64(message.value);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterMetricRequest
*/
const RegisterMetricRequest = new RegisterMetricRequest$Type();
var RegisterMetricResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.RegisterMetricResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.RegisterMetricResponse
*/
const RegisterMetricResponse = new RegisterMetricResponse$Type();
var GetMetricsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMetricsRequest", [{
			no: 1,
			name: "uuids",
			kind: "scalar",
			repeat: 2,
			T: 9
		}, {
			no: 2,
			name: "kinds",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuids = [];
		message.kinds = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuids.push(reader.string());
					break;
				case 2:
					message.kinds.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.uuids.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.uuids[i]);
		for (let i = 0; i < message.kinds.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.kinds[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMetricsRequest
*/
const GetMetricsRequest = new GetMetricsRequest$Type();
var GetMetricsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMetricsResponse", [{
			no: 1,
			name: "documents",
			kind: "map",
			K: 9,
			V: {
				kind: "message",
				T: () => DocumentMetrics
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.documents = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					this.binaryReadMap1(message.documents, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap1(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = DocumentMetrics.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.GetMetricsResponse.documents");
			}
		}
		map[key ?? ""] = val ?? DocumentMetrics.create();
	}
	internalBinaryWrite(message, writer, options) {
		for (let k of globalThis.Object.keys(message.documents)) {
			writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			DocumentMetrics.internalBinaryWrite(message.documents[k], writer, options);
			writer.join().join();
		}
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMetricsResponse
*/
const GetMetricsResponse = new GetMetricsResponse$Type();
var DocumentMetrics$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DocumentMetrics", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "metrics",
			kind: "message",
			repeat: 2,
			T: () => Metric
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.metrics = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.metrics.push(Metric.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		for (let i = 0; i < message.metrics.length; i++) Metric.internalBinaryWrite(message.metrics[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DocumentMetrics
*/
const DocumentMetrics = new DocumentMetrics$Type();
var Metric$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.Metric", [
			{
				no: 1,
				name: "kind",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "label",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "value",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.kind = "";
		message.label = "";
		message.value = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.kind = reader.string();
					break;
				case 2:
					message.label = reader.string();
					break;
				case 3:
					message.value = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.kind !== "") writer.tag(1, WireType.LengthDelimited).string(message.kind);
		if (message.label !== "") writer.tag(2, WireType.LengthDelimited).string(message.label);
		if (message.value !== 0n) writer.tag(3, WireType.Varint).int64(message.value);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.Metric
*/
const Metric = new Metric$Type();
var LockRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.LockRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "ttl",
				kind: "scalar",
				T: 5
			},
			{
				no: 3,
				name: "app",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "comment",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "exclusivity",
				kind: "enum",
				T: () => ["elephant.repository.LockExclusivity", LockExclusivity]
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.ttl = 0;
		message.app = "";
		message.comment = "";
		message.exclusivity = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.ttl = reader.int32();
					break;
				case 3:
					message.app = reader.string();
					break;
				case 4:
					message.comment = reader.string();
					break;
				case 5:
					message.exclusivity = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.ttl !== 0) writer.tag(2, WireType.Varint).int32(message.ttl);
		if (message.app !== "") writer.tag(3, WireType.LengthDelimited).string(message.app);
		if (message.comment !== "") writer.tag(4, WireType.LengthDelimited).string(message.comment);
		if (message.exclusivity !== 0) writer.tag(5, WireType.Varint).int32(message.exclusivity);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.LockRequest
*/
const LockRequest = new LockRequest$Type();
var LockResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.LockResponse", [{
			no: 1,
			name: "token",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "expires",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.token = "";
		message.expires = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.token = reader.string();
					break;
				case 2:
					message.expires = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
		if (message.expires !== "") writer.tag(2, WireType.LengthDelimited).string(message.expires);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.LockResponse
*/
const LockResponse = new LockResponse$Type();
var AcquireLock$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.AcquireLock", [
			{
				no: 1,
				name: "ttl",
				kind: "scalar",
				T: 5
			},
			{
				no: 2,
				name: "app",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "comment",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "exclusivity",
				kind: "enum",
				T: () => ["elephant.repository.LockExclusivity", LockExclusivity]
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.ttl = 0;
		message.app = "";
		message.comment = "";
		message.exclusivity = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.ttl = reader.int32();
					break;
				case 2:
					message.app = reader.string();
					break;
				case 3:
					message.comment = reader.string();
					break;
				case 4:
					message.exclusivity = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.ttl !== 0) writer.tag(1, WireType.Varint).int32(message.ttl);
		if (message.app !== "") writer.tag(2, WireType.LengthDelimited).string(message.app);
		if (message.comment !== "") writer.tag(3, WireType.LengthDelimited).string(message.comment);
		if (message.exclusivity !== 0) writer.tag(4, WireType.Varint).int32(message.exclusivity);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.AcquireLock
*/
const AcquireLock = new AcquireLock$Type();
var LockGrant$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.LockGrant", [{
			no: 1,
			name: "token",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "expires",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.token = "";
		message.expires = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.token = reader.string();
					break;
				case 2:
					message.expires = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
		if (message.expires !== "") writer.tag(2, WireType.LengthDelimited).string(message.expires);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.LockGrant
*/
const LockGrant = new LockGrant$Type();
var ExtendLockRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ExtendLockRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "ttl",
				kind: "scalar",
				T: 5
			},
			{
				no: 3,
				name: "token",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.ttl = 0;
		message.token = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.ttl = reader.int32();
					break;
				case 3:
					message.token = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.ttl !== 0) writer.tag(2, WireType.Varint).int32(message.ttl);
		if (message.token !== "") writer.tag(3, WireType.LengthDelimited).string(message.token);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ExtendLockRequest
*/
const ExtendLockRequest = new ExtendLockRequest$Type();
var UnlockRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UnlockRequest", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "token",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.token = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.token = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.token !== "") writer.tag(2, WireType.LengthDelimited).string(message.token);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UnlockRequest
*/
const UnlockRequest = new UnlockRequest$Type();
var UnlockResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.UnlockResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.UnlockResponse
*/
const UnlockResponse = new UnlockResponse$Type();
var GetWithheldRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetWithheldRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetWithheldRequest
*/
const GetWithheldRequest = new GetWithheldRequest$Type();
var GetWithheldResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetWithheldResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => ScheduledDocument
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(ScheduledDocument.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) ScheduledDocument.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetWithheldResponse
*/
const GetWithheldResponse = new GetWithheldResponse$Type();
var ScheduledDocument$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ScheduledDocument", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "status_id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 4,
				name: "document_version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 5,
				name: "planning_item",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "assignment",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "publish",
				kind: "scalar",
				T: 9
			},
			{
				no: 8,
				name: "scheduled_by",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.type = "";
		message.statusId = 0n;
		message.documentVersion = 0n;
		message.planningItem = "";
		message.assignment = "";
		message.publish = "";
		message.scheduledBy = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.type = reader.string();
					break;
				case 3:
					message.statusId = reader.int64().toBigInt();
					break;
				case 4:
					message.documentVersion = reader.int64().toBigInt();
					break;
				case 5:
					message.planningItem = reader.string();
					break;
				case 6:
					message.assignment = reader.string();
					break;
				case 7:
					message.publish = reader.string();
					break;
				case 8:
					message.scheduledBy = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		if (message.statusId !== 0n) writer.tag(3, WireType.Varint).int64(message.statusId);
		if (message.documentVersion !== 0n) writer.tag(4, WireType.Varint).int64(message.documentVersion);
		if (message.planningItem !== "") writer.tag(5, WireType.LengthDelimited).string(message.planningItem);
		if (message.assignment !== "") writer.tag(6, WireType.LengthDelimited).string(message.assignment);
		if (message.publish !== "") writer.tag(7, WireType.LengthDelimited).string(message.publish);
		if (message.scheduledBy !== "") writer.tag(8, WireType.LengthDelimited).string(message.scheduledBy);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ScheduledDocument
*/
const ScheduledDocument = new ScheduledDocument$Type();
var GetDeliverableInfoRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetDeliverableInfoRequest", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetDeliverableInfoRequest
*/
const GetDeliverableInfoRequest = new GetDeliverableInfoRequest$Type();
var GetDeliverableInfoResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetDeliverableInfoResponse", [
			{
				no: 1,
				name: "has_planning_info",
				kind: "scalar",
				T: 8
			},
			{
				no: 2,
				name: "planning_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "assignment_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "event_uuid",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.hasPlanningInfo = false;
		message.planningUuid = "";
		message.assignmentUuid = "";
		message.eventUuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.hasPlanningInfo = reader.bool();
					break;
				case 2:
					message.planningUuid = reader.string();
					break;
				case 3:
					message.assignmentUuid = reader.string();
					break;
				case 4:
					message.eventUuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.hasPlanningInfo !== false) writer.tag(1, WireType.Varint).bool(message.hasPlanningInfo);
		if (message.planningUuid !== "") writer.tag(2, WireType.LengthDelimited).string(message.planningUuid);
		if (message.assignmentUuid !== "") writer.tag(3, WireType.LengthDelimited).string(message.assignmentUuid);
		if (message.eventUuid !== "") writer.tag(4, WireType.LengthDelimited).string(message.eventUuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetDeliverableInfoResponse
*/
const GetDeliverableInfoResponse = new GetDeliverableInfoResponse$Type();
var BulkGetDeliverableInfoRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.BulkGetDeliverableInfoRequest", [{
			no: 1,
			name: "uuids",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuids = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuids.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.uuids.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.uuids[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.BulkGetDeliverableInfoRequest
*/
const BulkGetDeliverableInfoRequest = new BulkGetDeliverableInfoRequest$Type();
var BulkGetDeliverableInfoResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.BulkGetDeliverableInfoResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => DeliverableInfo
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(DeliverableInfo.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) DeliverableInfo.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.BulkGetDeliverableInfoResponse
*/
const BulkGetDeliverableInfoResponse = new BulkGetDeliverableInfoResponse$Type();
var DeliverableInfo$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DeliverableInfo", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "planning_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "assignment_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "event_uuid",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.planningUuid = "";
		message.assignmentUuid = "";
		message.eventUuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.planningUuid = reader.string();
					break;
				case 3:
					message.assignmentUuid = reader.string();
					break;
				case 4:
					message.eventUuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.planningUuid !== "") writer.tag(2, WireType.LengthDelimited).string(message.planningUuid);
		if (message.assignmentUuid !== "") writer.tag(3, WireType.LengthDelimited).string(message.assignmentUuid);
		if (message.eventUuid !== "") writer.tag(4, WireType.LengthDelimited).string(message.eventUuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DeliverableInfo
*/
const DeliverableInfo = new DeliverableInfo$Type();
var CreateUploadRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.CreateUploadRequest", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "content_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "meta",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.contentType = "";
		message.meta = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.contentType = reader.string();
					break;
				case 3:
					this.binaryReadMap3(message.meta, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap3(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.CreateUploadRequest.meta");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.contentType !== "") writer.tag(2, WireType.LengthDelimited).string(message.contentType);
		for (let k of globalThis.Object.keys(message.meta)) writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.meta[k]).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.CreateUploadRequest
*/
const CreateUploadRequest = new CreateUploadRequest$Type();
var CreateUploadResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.CreateUploadResponse", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "url",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = "";
		message.url = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.string();
					break;
				case 2:
					message.url = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== "") writer.tag(1, WireType.LengthDelimited).string(message.id);
		if (message.url !== "") writer.tag(2, WireType.LengthDelimited).string(message.url);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.CreateUploadResponse
*/
const CreateUploadResponse = new CreateUploadResponse$Type();
var GetAttachmentsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetAttachmentsRequest", [
			{
				no: 1,
				name: "documents",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 2,
				name: "attachment_name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "download_link",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.documents = [];
		message.attachmentName = "";
		message.downloadLink = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.documents.push(reader.string());
					break;
				case 2:
					message.attachmentName = reader.string();
					break;
				case 3:
					message.downloadLink = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.documents.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.documents[i]);
		if (message.attachmentName !== "") writer.tag(2, WireType.LengthDelimited).string(message.attachmentName);
		if (message.downloadLink !== false) writer.tag(3, WireType.Varint).bool(message.downloadLink);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetAttachmentsRequest
*/
const GetAttachmentsRequest = new GetAttachmentsRequest$Type();
var GetAttachmentsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetAttachmentsResponse", [{
			no: 1,
			name: "attachments",
			kind: "message",
			repeat: 2,
			T: () => AttachmentDetails
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.attachments = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.attachments.push(AttachmentDetails.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.attachments.length; i++) AttachmentDetails.internalBinaryWrite(message.attachments[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetAttachmentsResponse
*/
const GetAttachmentsResponse = new GetAttachmentsResponse$Type();
var AttachmentDetails$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.AttachmentDetails", [
			{
				no: 1,
				name: "document",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 4,
				name: "download_link",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "filename",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "content_type",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.document = "";
		message.name = "";
		message.version = 0n;
		message.downloadLink = "";
		message.filename = "";
		message.contentType = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.document = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				case 3:
					message.version = reader.int64().toBigInt();
					break;
				case 4:
					message.downloadLink = reader.string();
					break;
				case 5:
					message.filename = reader.string();
					break;
				case 6:
					message.contentType = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.document !== "") writer.tag(1, WireType.LengthDelimited).string(message.document);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		if (message.version !== 0n) writer.tag(3, WireType.Varint).int64(message.version);
		if (message.downloadLink !== "") writer.tag(4, WireType.LengthDelimited).string(message.downloadLink);
		if (message.filename !== "") writer.tag(5, WireType.LengthDelimited).string(message.filename);
		if (message.contentType !== "") writer.tag(6, WireType.LengthDelimited).string(message.contentType);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.AttachmentDetails
*/
const AttachmentDetails = new AttachmentDetails$Type();
var ConfigureTypeRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ConfigureTypeRequest", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "configuration",
			kind: "message",
			T: () => TypeConfiguration
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.configuration = TypeConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.configuration);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.configuration) TypeConfiguration.internalBinaryWrite(message.configuration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ConfigureTypeRequest
*/
const ConfigureTypeRequest = new ConfigureTypeRequest$Type();
var TypeConfiguration$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.TypeConfiguration", [
			{
				no: 1,
				name: "bounded_collection",
				kind: "scalar",
				T: 8
			},
			{
				no: 2,
				name: "time_expressions",
				kind: "message",
				repeat: 2,
				T: () => TypeTimeExpression
			},
			{
				no: 3,
				name: "label_expressions",
				kind: "message",
				repeat: 2,
				T: () => LabelExpression
			},
			{
				no: 4,
				name: "variants",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 5,
				name: "evict_noncurrent_after",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.boundedCollection = false;
		message.timeExpressions = [];
		message.labelExpressions = [];
		message.variants = [];
		message.evictNoncurrentAfter = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.boundedCollection = reader.bool();
					break;
				case 2:
					message.timeExpressions.push(TypeTimeExpression.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 3:
					message.labelExpressions.push(LabelExpression.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 4:
					message.variants.push(reader.string());
					break;
				case 5:
					message.evictNoncurrentAfter = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.boundedCollection !== false) writer.tag(1, WireType.Varint).bool(message.boundedCollection);
		for (let i = 0; i < message.timeExpressions.length; i++) TypeTimeExpression.internalBinaryWrite(message.timeExpressions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.labelExpressions.length; i++) LabelExpression.internalBinaryWrite(message.labelExpressions[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.variants.length; i++) writer.tag(4, WireType.LengthDelimited).string(message.variants[i]);
		if (message.evictNoncurrentAfter !== 0n) writer.tag(5, WireType.Varint).int64(message.evictNoncurrentAfter);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.TypeConfiguration
*/
const TypeConfiguration = new TypeConfiguration$Type();
var TypeTimeExpression$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.TypeTimeExpression", [
			{
				no: 1,
				name: "expression",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "layout",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "timezone",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.expression = "";
		message.layout = "";
		message.timezone = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.expression = reader.string();
					break;
				case 2:
					message.layout = reader.string();
					break;
				case 3:
					message.timezone = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.expression !== "") writer.tag(1, WireType.LengthDelimited).string(message.expression);
		if (message.layout !== "") writer.tag(2, WireType.LengthDelimited).string(message.layout);
		if (message.timezone !== "") writer.tag(3, WireType.LengthDelimited).string(message.timezone);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.TypeTimeExpression
*/
const TypeTimeExpression = new TypeTimeExpression$Type();
var LabelExpression$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.LabelExpression", [{
			no: 1,
			name: "expression",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "template",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.expression = "";
		message.template = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.expression = reader.string();
					break;
				case 2:
					message.template = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.expression !== "") writer.tag(1, WireType.LengthDelimited).string(message.expression);
		if (message.template !== "") writer.tag(2, WireType.LengthDelimited).string(message.template);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.LabelExpression
*/
const LabelExpression = new LabelExpression$Type();
var ConfigureTypeResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.ConfigureTypeResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.ConfigureTypeResponse
*/
const ConfigureTypeResponse = new ConfigureTypeResponse$Type();
var GetTypeConfigurationRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetTypeConfigurationRequest", [{
			no: 1,
			name: "type",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetTypeConfigurationRequest
*/
const GetTypeConfigurationRequest = new GetTypeConfigurationRequest$Type();
var GetTypeConfigurationResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetTypeConfigurationResponse", [{
			no: 1,
			name: "configuration",
			kind: "message",
			T: () => TypeConfiguration
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.configuration = TypeConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.configuration);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.configuration) TypeConfiguration.internalBinaryWrite(message.configuration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetTypeConfigurationResponse
*/
const GetTypeConfigurationResponse = new GetTypeConfigurationResponse$Type();
var GetMatchingRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMatchingRequest", [
			{
				no: 1,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "timespan",
				kind: "message",
				T: () => Timespan
			},
			{
				no: 3,
				name: "labels",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 4,
				name: "filter",
				kind: "message",
				T: () => DocumentFilter
			},
			{
				no: 5,
				name: "include_documents",
				kind: "scalar",
				T: 8
			},
			{
				no: 6,
				name: "include_meta",
				kind: "scalar",
				T: 8
			},
			{
				no: 7,
				name: "include",
				kind: "scalar",
				repeat: 2,
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.type = "";
		message.labels = [];
		message.includeDocuments = false;
		message.includeMeta = false;
		message.include = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.type = reader.string();
					break;
				case 2:
					message.timespan = Timespan.internalBinaryRead(reader, reader.uint32(), options, message.timespan);
					break;
				case 3:
					message.labels.push(reader.string());
					break;
				case 4:
					message.filter = DocumentFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
					break;
				case 5:
					message.includeDocuments = reader.bool();
					break;
				case 6:
					message.includeMeta = reader.bool();
					break;
				case 7:
					message.include.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.type !== "") writer.tag(1, WireType.LengthDelimited).string(message.type);
		if (message.timespan) Timespan.internalBinaryWrite(message.timespan, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.labels.length; i++) writer.tag(3, WireType.LengthDelimited).string(message.labels[i]);
		if (message.filter) DocumentFilter.internalBinaryWrite(message.filter, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		if (message.includeDocuments !== false) writer.tag(5, WireType.Varint).bool(message.includeDocuments);
		if (message.includeMeta !== false) writer.tag(6, WireType.Varint).bool(message.includeMeta);
		for (let i = 0; i < message.include.length; i++) writer.tag(7, WireType.LengthDelimited).string(message.include[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMatchingRequest
*/
const GetMatchingRequest = new GetMatchingRequest$Type();
var GetMatchingResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetMatchingResponse", [{
			no: 1,
			name: "matches",
			kind: "message",
			repeat: 2,
			T: () => DocumentMatch
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.matches = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.matches.push(DocumentMatch.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.matches.length; i++) DocumentMatch.internalBinaryWrite(message.matches[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetMatchingResponse
*/
const GetMatchingResponse = new GetMatchingResponse$Type();
var DocumentMatch$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DocumentMatch", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "document",
				kind: "message",
				T: () => Document
			},
			{
				no: 4,
				name: "meta",
				kind: "message",
				T: () => DocumentMeta
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.version = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				case 4:
					message.meta = DocumentMeta.internalBinaryRead(reader, reader.uint32(), options, message.meta);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		if (message.meta) DocumentMeta.internalBinaryWrite(message.meta, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DocumentMatch
*/
const DocumentMatch = new DocumentMatch$Type();
var DocumentFilter$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.DocumentFilter", [
			{
				no: 1,
				name: "expression",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "operator",
				kind: "enum",
				T: () => ["elephant.repository.FilterOperator", FilterOperator]
			},
			{
				no: 3,
				name: "values",
				kind: "message",
				repeat: 2,
				T: () => FilterValues
			},
			{
				no: 4,
				name: "and",
				kind: "message",
				repeat: 2,
				T: () => DocumentFilter
			},
			{
				no: 5,
				name: "or",
				kind: "message",
				repeat: 2,
				T: () => DocumentFilter
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.expression = "";
		message.operator = 0;
		message.values = [];
		message.and = [];
		message.or = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.expression = reader.string();
					break;
				case 2:
					message.operator = reader.int32();
					break;
				case 3:
					message.values.push(FilterValues.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 4:
					message.and.push(DocumentFilter.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 5:
					message.or.push(DocumentFilter.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.expression !== "") writer.tag(1, WireType.LengthDelimited).string(message.expression);
		if (message.operator !== 0) writer.tag(2, WireType.Varint).int32(message.operator);
		for (let i = 0; i < message.values.length; i++) FilterValues.internalBinaryWrite(message.values[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.and.length; i++) DocumentFilter.internalBinaryWrite(message.and[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.or.length; i++) DocumentFilter.internalBinaryWrite(message.or[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.DocumentFilter
*/
const DocumentFilter = new DocumentFilter$Type();
var FilterValues$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.FilterValues", [{
			no: 1,
			name: "values",
			kind: "map",
			K: 9,
			V: {
				kind: "scalar",
				T: 9
			}
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.values = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					this.binaryReadMap1(message.values, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap1(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.repository.FilterValues.values");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		for (let k of globalThis.Object.keys(message.values)) writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.values[k]).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.FilterValues
*/
const FilterValues = new FilterValues$Type();
var GetSocketTokenRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetSocketTokenRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetSocketTokenRequest
*/
const GetSocketTokenRequest = new GetSocketTokenRequest$Type();
var GetSocketTokenResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.repository.GetSocketTokenResponse", [{
			no: 1,
			name: "token",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "expires",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.token = "";
		message.expires = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.token = reader.string();
					break;
				case 2:
					message.expires = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
		if (message.expires !== "") writer.tag(2, WireType.LengthDelimited).string(message.expires);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.repository.GetSocketTokenResponse
*/
const GetSocketTokenResponse = new GetSocketTokenResponse$Type();
/**
* @generated ServiceType for protobuf service elephant.repository.Documents
*/
const Documents = new ServiceType("elephant.repository.Documents", [
	{
		name: "Get",
		options: {},
		I: GetDocumentRequest,
		O: GetDocumentResponse
	},
	{
		name: "BulkGet",
		options: {},
		I: BulkGetRequest,
		O: BulkGetResponse
	},
	{
		name: "GetHistory",
		options: {},
		I: GetHistoryRequest,
		O: GetHistoryResponse
	},
	{
		name: "Update",
		options: {},
		I: UpdateRequest,
		O: UpdateResponse
	},
	{
		name: "BulkUpdate",
		options: {},
		I: BulkUpdateRequest,
		O: BulkUpdateResponse
	},
	{
		name: "Validate",
		options: {},
		I: ValidateRequest,
		O: ValidateResponse
	},
	{
		name: "Prune",
		options: {},
		I: PruneRequest,
		O: PruneResponse
	},
	{
		name: "Evict",
		options: {},
		I: EvictRequest,
		O: EvictResponse
	},
	{
		name: "Delete",
		options: {},
		I: DeleteDocumentRequest,
		O: DeleteDocumentResponse
	},
	{
		name: "ListDeleted",
		options: {},
		I: ListDeletedRequest,
		O: ListDeletedResponse
	},
	{
		name: "Restore",
		options: {},
		I: RestoreRequest,
		O: RestoreResponse
	},
	{
		name: "Purge",
		options: {},
		I: PurgeRequest,
		O: PurgeResponse
	},
	{
		name: "GetMeta",
		options: {},
		I: GetMetaRequest,
		O: GetMetaResponse
	},
	{
		name: "Eventlog",
		options: {},
		I: GetEventlogRequest,
		O: GetEventlogResponse
	},
	{
		name: "CompactedEventlog",
		options: {},
		I: GetCompactedEventlogRequest,
		O: GetCompactedEventlogResponse
	},
	{
		name: "GetStatus",
		options: {},
		I: GetStatusRequest,
		O: GetStatusResponse
	},
	{
		name: "GetStatusHistory",
		options: {},
		I: GetStatusHistoryRequest,
		O: GetStatusHistoryReponse
	},
	{
		name: "GetNilStatuses",
		options: {},
		I: GetNilStatusesRequest,
		O: GetNilStatusesResponse
	},
	{
		name: "GetStatusOverview",
		options: {},
		I: GetStatusOverviewRequest,
		O: GetStatusOverviewResponse
	},
	{
		name: "GetPermissions",
		options: {},
		I: GetPermissionsRequest,
		O: GetPermissionsResponse
	},
	{
		name: "Lock",
		options: {},
		I: LockRequest,
		O: LockResponse
	},
	{
		name: "ExtendLock",
		options: {},
		I: ExtendLockRequest,
		O: LockResponse
	},
	{
		name: "Unlock",
		options: {},
		I: UnlockRequest,
		O: UnlockResponse
	},
	{
		name: "GetWithheld",
		options: {},
		I: GetWithheldRequest,
		O: GetWithheldResponse
	},
	{
		name: "GetDeliverableInfo",
		options: {},
		I: GetDeliverableInfoRequest,
		O: GetDeliverableInfoResponse
	},
	{
		name: "BulkGetDeliverableInfo",
		options: {},
		I: BulkGetDeliverableInfoRequest,
		O: BulkGetDeliverableInfoResponse
	},
	{
		name: "CreateUpload",
		options: {},
		I: CreateUploadRequest,
		O: CreateUploadResponse
	},
	{
		name: "GetAttachments",
		options: {},
		I: GetAttachmentsRequest,
		O: GetAttachmentsResponse
	},
	{
		name: "GetMatching",
		options: {},
		I: GetMatchingRequest,
		O: GetMatchingResponse
	},
	{
		name: "GetSocketToken",
		options: {},
		I: GetSocketTokenRequest,
		O: GetSocketTokenResponse
	}
]);
/**
* @generated ServiceType for protobuf service elephant.repository.Schemas
*/
const Schemas = new ServiceType("elephant.repository.Schemas", [
	{
		name: "RegisterGeneration",
		options: {},
		I: RegisterGenerationRequest,
		O: RegisterGenerationResponse
	},
	{
		name: "SetActive",
		options: {},
		I: SetActiveSchemasRequest,
		O: SetActiveSchemasResponse
	},
	{
		name: "ListGenerations",
		options: {},
		I: ListSchemaGenerationsRequest,
		O: ListSchemaGenerationsResponse
	},
	{
		name: "GetExemplars",
		options: {},
		I: GetExemplarsRequest,
		O: GetExemplarsResponse
	},
	{
		name: "Get",
		options: {},
		I: GetSchemaRequest,
		O: GetSchemaResponse
	},
	{
		name: "GetAllActive",
		options: {},
		I: GetAllActiveSchemasRequest,
		O: GetAllActiveSchemasResponse
	},
	{
		name: "ListActive",
		options: {},
		I: ListActiveSchemasRequest,
		O: ListActiveSchemasResponse
	},
	{
		name: "RegisterMetaType",
		options: {},
		I: RegisterMetaTypeRequest,
		O: RegisterMetaTypeResponse
	},
	{
		name: "RegisterMetaTypeUse",
		options: {},
		I: RegisterMetaTypeUseRequest,
		O: RegisterMetaTypeUseResponse
	},
	{
		name: "GetMetaTypes",
		options: {},
		I: GetMetaTypesRequest,
		O: GetMetaTypesResponse
	},
	{
		name: "GetDeprecations",
		options: {},
		I: GetDeprecationsRequest,
		O: GetDeprecationsResponse
	},
	{
		name: "UpdateDeprecation",
		options: {},
		I: UpdateDeprecationRequest,
		O: UpdateDeprecationResponse
	},
	{
		name: "GetDocumentTypes",
		options: {},
		I: GetDocumentTypesRequest,
		O: GetDocumentTypesResponse
	},
	{
		name: "ConfigureType",
		options: {},
		I: ConfigureTypeRequest,
		O: ConfigureTypeResponse
	},
	{
		name: "GetTypeConfiguration",
		options: {},
		I: GetTypeConfigurationRequest,
		O: GetTypeConfigurationResponse
	}
]);
/**
* @generated ServiceType for protobuf service elephant.repository.Workflows
*/
const Workflows = new ServiceType("elephant.repository.Workflows", [
	{
		name: "UpdateStatus",
		options: {},
		I: UpdateStatusRequest,
		O: UpdateStatusResponse
	},
	{
		name: "GetStatuses",
		options: {},
		I: GetStatusesRequest,
		O: GetStatusesResponse
	},
	{
		name: "CreateStatusRule",
		options: {},
		I: CreateStatusRuleRequest,
		O: CreateStatusRuleResponse
	},
	{
		name: "DeleteStatusRule",
		options: {},
		I: DeleteStatusRuleRequest,
		O: DeleteStatusRuleResponse
	},
	{
		name: "GetStatusRules",
		options: {},
		I: GetStatusRulesRequest,
		O: GetStatusRulesResponse
	},
	{
		name: "SetWorkflow",
		options: {},
		I: SetWorkflowRequest,
		O: SetWorkflowResponse
	},
	{
		name: "GetWorkflow",
		options: {},
		I: GetWorkflowRequest,
		O: GetWorkflowResponse
	},
	{
		name: "DeleteWorkflow",
		options: {},
		I: DeleteWorkflowRequest,
		O: DeleteWorkflowResponse
	}
]);
/**
* @generated ServiceType for protobuf service elephant.repository.Metrics
*/
const Metrics = new ServiceType("elephant.repository.Metrics", [
	{
		name: "RegisterKind",
		options: {},
		I: RegisterMetricKindRequest,
		O: RegisterMetricKindResponse
	},
	{
		name: "DeleteKind",
		options: {},
		I: DeleteMetricKindRequest,
		O: DeleteMetricKindResponse
	},
	{
		name: "GetKinds",
		options: {},
		I: GetMetricKindsRequest,
		O: GetMetricKindsResponse
	},
	{
		name: "RegisterMetric",
		options: {},
		I: RegisterMetricRequest,
		O: RegisterMetricResponse
	},
	{
		name: "GetMetrics",
		options: {},
		I: GetMetricsRequest,
		O: GetMetricsResponse
	}
]);
export { GetCompactedEventlogResponse as $, UpdateRequest as $n, ListDeletedRequest as $t, DocumentFilter as A, ScheduledDocument as An, GetSchemaResponse as At, EvictRequest as B, Status as Bn, GetStatusRulesResponse as Bt, DeleteRecord as C, RegisterMetaTypeUseResponse as Cn, GetMetricsRequest as Ct, DeleteWorkflowResponse as D, RegisterMetricResponse as Dn, GetPermissionsRequest as Dt, DeleteWorkflowRequest as E, RegisterMetricRequest as En, GetNilStatusesResponse as Et, DocumentVersion as F, Schemas as Fn, GetStatusOverviewRequest as Ft, ExtractedValues as G, TypeConfiguration as Gn, GetWithheldRequest as Gt, Exemplar as H, StatusRule as Hn, GetStatusesResponse as Ht, DocumentWorkflow as I, SetActiveSchemasRequest as In, GetStatusOverviewResponse as It, GetAllActiveSchemasRequest as J, UnlockResponse as Jn, GetWorkflowResponse as Jt, FilterOperator as K, TypeTimeExpression as Kn, GetWithheldResponse as Kt, Documents as L, SetActiveSchemasResponse as Ln, GetStatusRequest as Lt, DocumentMeta as M, SchemaActivation as Mn, GetSocketTokenResponse as Mt, DocumentMetrics as N, SchemaGeneration as Nn, GetStatusHistoryReponse as Nt, DeliverableInfo as O, RestoreRequest as On, GetPermissionsResponse as Ot, DocumentStatuses as P, SchemaReference as Pn, GetStatusHistoryRequest as Pt, GetCompactedEventlogRequest as Q, UpdatePermissionsResponse as Qn, ListActiveSchemasResponse as Qt, EntityRef as R, SetWorkflowRequest as Rn, GetStatusResponse as Rt, DeleteMetricKindResponse as S, RegisterMetaTypeUseRequest as Sn, GetMetricKindsResponse as St, DeleteStatusRuleResponse as T, RegisterMetricKindResponse as Tn, GetNilStatusesRequest as Tt, ExtendLockRequest as U, StatusUpdate as Un, GetTypeConfigurationRequest as Ut, EvictResponse as V, StatusOverviewItem as Vn, GetStatusesRequest as Vt, ExtractedValue as W, Timespan as Wn, GetTypeConfigurationResponse as Wt, GetAttachmentsRequest as X, UpdateDeprecationResponse as Xn, LabelExpression as Xt, GetAllActiveSchemasResponse as Y, UpdateDeprecationRequest as Yn, ImportDirective as Yt, GetAttachmentsResponse as Z, UpdatePermissionsRequest as Zn, ListActiveSchemasRequest as Zt, CreateUploadRequest as _, PurgeResponse as _n, GetMetaRequest as _t, BulkGetDeliverableInfoRequest as a, LockGrant as an, ValidationResult as ar, GetDocumentResponse as at, DeleteDocumentResponse as b, RegisterMetaTypeRequest as bn, GetMetaTypesResponse as bt, BulkGetReference as c, MetaDocument as cn, GetEventlogRequest as ct, BulkUpdateRequest as d, MetricAggregation as dn, GetExemplarsResponse as dt, ListDeletedResponse as en, UpdateResponse as er, GetDeliverableInfoRequest as et, BulkUpdateResponse as f, MetricKind as fn, GetHistoryRequest as ft, CreateStatusRuleResponse as g, PurgeRequest as gn, GetMetaDoc as gt, CreateStatusRuleRequest as h, PruneResponse as hn, GetMatchingResponse as ht, AttachmentRef as i, LockExclusivity as in, ValidateResponse as ir, GetDocumentRequest as it, DocumentMatch as j, Schema as jn, GetSocketTokenRequest as jt, Deprecation as k, RestoreResponse as kn, GetSchemaRequest as kt, BulkGetRequest as l, MetaTypeInfo as ln, GetEventlogResponse as lt, ConfigureTypeResponse as m, PruneRequest as mn, GetMatchingRequest as mt, AcquireLock as n, ListSchemaGenerationsResponse as nn, UpdateStatusResponse as nr, GetDeprecationsRequest as nt, BulkGetDeliverableInfoResponse as o, LockRequest as on, WorkflowStatus as or, GetDocumentTypesRequest as ot, ConfigureTypeRequest as p, Metrics as pn, GetHistoryResponse as pt, FilterValues as q, UnlockRequest as qn, GetWorkflowRequest as qt, AttachmentDetails as r, Lock as rn, ValidateRequest as rr, GetDeprecationsResponse as rt, BulkGetItem as s, LockResponse as sn, Workflows as sr, GetDocumentTypesResponse as st, ACLEntry as t, ListSchemaGenerationsRequest as tn, UpdateStatusRequest as tr, GetDeliverableInfoResponse as tt, BulkGetResponse as u, Metric as un, GetExemplarsRequest as ut, CreateUploadResponse as v, RegisterGenerationRequest as vn, GetMetaResponse as vt, DeleteStatusRuleRequest as w, RegisterMetricKindRequest as wn, GetMetricsResponse as wt, DeleteMetricKindRequest as x, RegisterMetaTypeResponse as xn, GetMetricKindsRequest as xt, DeleteDocumentRequest as y, RegisterGenerationResponse as yn, GetMetaTypesRequest as yt, EventlogItem as z, SetWorkflowResponse as zn, GetStatusRulesRequest as zt };
